import React, { Component } from "react";
import { Link } from "react-router-dom";
import Modal from "react-responsive-modal";
import "../assets/css/site.css";

import SweetAlert from "react-bootstrap-sweetalert";
import {
  Button,
	Nav,
	NavItem,
	NavLink,
	TabContent,
	TabPane,
  Col, 
  FormGroup, 
  Form,
  Label,
} from 'reactstrap';

// koneksi
import { Post, Get, Delete, ID_DESA, GetEksternal, GetMain, JENIS_DESA, Nama_DESA } from "../function/Koneksi";
import { DataToken, formatDMY, formatHIS, CapitalizeWord } from "../function/Format";
import { contactPerson } from '../function/get-data';
import classnames from 'classnames';
import { Redirect } from "react-router-dom";

import Datetime from 'react-datetime';
import Dropzone from "react-dropzone";

import Select from 'react-select';
import BootstrapTable from "react-bootstrap-table-next";

import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
// Carousel
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import HighchartsReact from 'highcharts-react-official';
import drilldown from 'highcharts/modules/drilldown';

var HtmlToReactParser = require("html-to-react").Parser;

// Carousel
const responsive = {
  mobile: {
    breakpoint: { max: 3000, min: 0 },
    items: 1,
    slidesToSlide: 1 // optional, default to 1.
  }
};

const frmInput = {
  uuid: '',
  nomor_surat: '',
  uraian_singkat: '',
  dari: '',
  tujuan_surat: '',
  perihal: '',
  tanggal_masuk: new Date(),
  keterangan: '',
  file: '',
  link_gambar: '',
};

class Dashboard extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      paid: null,
      lisensi: null,
      alert: null,
      show: false,
      basicTitle: "",
      basicType: "default",
      pesanAlert: "",
      layanan: [],
      layananSuratBaru: [],
      layananInternal: [],
      layananSuratBaruPermanent: [],
      layananKecamatan: [],
      perizinan: [],
      jumlahMenungguEksekusi: 0,
      jumlahSelesai: 0,
      jumlahCatatanMenungguEksekusi: 0,
      jumlahVerifikasiMenungguEksekusi: 0,
      jumlahPengaduanDiajukan: 0,
      menuUtama: "inherit",
      menuWilayah: "none",
      menuPengaturan: "none",
      menuPerangkat: "none",
      menuLaporan: "none",
      menuAdministrasi: "none",
      menuSuku: "none",
      menuLayanan: "none",
      menuPerubahanData: "none",
      active_tab_icon : '1',

			link_gambar_show: '',
			data_cek: 'Kosong',
      akun: DataToken(sessionStorage.getItem("access_token")),
      loading: true,
      loadingBannerDashboard: true,
      loadingListLayanan: true,
      loadingGrafik: true,
      loadingPreview: false,

      // Data Version App
      dataVersion: null,
      status: {
        modalVersion: false,
        select: false,
        modalDetailGrafik: false,
        alertExport: false,
        modalExport: false,
      },
      konfigurasi_layanan_operator: '',

      // Data Berita
      dataBerita: [],
      dataSetting: null,
      dataPerangkat: [],
      tampilGrafik: '',
      frmFilterStatistikPenduduk:[
        { value: 'pendidikan_warga', label: 'Pendidikan'},
        { value: 'rentang_usia', label: 'Rentang Umur'},
        { value: 'pekerjaan_warga', label: 'Pekerjaan'},
        { value: 'agama_warga', label: 'Agama'},
        { value: 'jenis_kelamin', label: 'Jenis Kelamin'},
        { value: 'golongan_darah_warga', label: 'Golongan Darah'},
        { value: 'bantuan_sosial', label: 'Bantuan Sosial'},
      ],
      statistik_penduduk: {
        mode: 'grafik',
        jenis: { value: 'pendidikan_warga', label: 'Pendidikan'},
        dusun: null,
        rw: null,
        rt: null,
      },
      frmDsn: [],
      frmRW: [],
      frmRT: [],
      // TabelGrafik
      data_detail: [],
      urlDetail: null,
      urlCari: "",
      // Pagination Detail
			awalDetail: '',
			sebelumDetail: '',
			halDetail: [],
			setelahDetail: '',
			akhirDetail: '',
      // Data Highcharts
      data_pendidikan: [],
			drilldown_data_pendidikan: [],
      data_usia: [],
			drilldown_data_usia: [],
      data_pekerjaan: [],
			drilldown_data_pekerjaan: [],
      data_agama: [],
			drilldown_data_agama: [],
      data_jenis_kelamin: [],
      drilldown_jenis_kelamin: [],
      // Statistik Potensi Desa
			data_potensi_penduduk: [],

      // Grafik Potensi
      data_grafik_potensi: [],
      drilldown_grafik_potensi: [],
      data_grafik_potensi_group: [],
      drilldown_grafik_potensi_group: [],
      loadingGrafikPotensi: true,
      data_grafik_potensi_dinamis: [],
      drilldown_grafik_potensi_dinamis: [],
      data_detail_grafik_potensi: [],
      urlDetailGrafikPotensi: null,
      urlCariGrafikPotensi: "",
      parentDetailPotensi:'',
      loadingGrafikPotensiDetail: false,
      frmSelectGrafikPotensiDetail: [],
      filterGrafikPotensiDetail: null,
      cariGrafikPotensiDetail: '',
      // Pagination Detail
      paginationDetailGrafikPotensi: [],
			awalDetailGrafikPotensi: '',
			sebelumDetailGrafikPotensi: '',
			halDetailGrafikPotensi: [],
			setelahDetailGrafikPotensi: '',
			akhirDetailGrafikPotensi: '',

      // export
      jenisDokumen: '',
      cariSurat: '',

      // Surat Masuk
      dataSuratMasuk: [],
      paginationSuratMasuk: [],
      statusSuratMasuk: {
        form: false,
        btnForm: false,
        btnAksi: false,
      },
      awalSuratMasuk: "",
      sebelumSuratMasuk: "",
      halSuratMasuk: [],
      setelahSuratMasuk: "",
      akhirSuratMasuk: "",
      loadingSuratMasuk: false,
      totalSuratMasuk:'0',
      dataCariSuratMasuk: {
        q:'',
      },
      dt: frmInput,
      fileSuratMasuk: '',
    };
  }

  
  // ================== Sweet Alert ==================
  closeAlert = () => {
    this.setState({
      show: false
    });
  };

  onRecieveInput = value => {
    this.setState({
      alert: (
        <SweetAlert success title="Nice!" onConfirm={this.hideAlert}>
          You wrote: {value}
        </SweetAlert>
      )
    });
  };

  hideAlert = () => {
    this.setState({
      alert: null
    });
  };

  componentDidMount() {
    this._isMounted = true
    this.fetchSuratMasuk({ page: null, where: [] });

    Get("perangkat/list", null, dtkat => {
      if(dtkat.results){
        let dataPerangkat = dtkat.results.reverse()
        this.setState({ dataPerangkat: dataPerangkat});
        // this.setState({ dataPerangkat: dtkat.results});
      }
    })

    Get('dusun/kel/' + ID_DESA + '/list', null, (data) => {
      let frmDsn = [];
      data.results.forEach((dt) => {
        frmDsn.push({ value: dt.id, label: dt.nama });
      });
      this.setState({ frmDsn });
    })

    let jenis_app = localStorage.getItem('JENIS_APLIKASI').toLowerCase();

    GetMain("master/version-app/status?app="+ jenis_app, null, data => {
      if(data.results){
        this.setState({
          dataVersion: data.results,
        })
      }
    })

    GetMain("main/web/list-layanan-desa", ID_DESA, data => {
      // if (this._isMounted) {
        if (data.result) {
        
          if(data.result.data_api.data_invoice!==null){
            let tgl = Date.now();
            let set_tgl = new Intl.DateTimeFormat('en-US', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(tgl);
            let ex_tgl = set_tgl.split("/");
            let hari_ini = ex_tgl[2] + "-" + ex_tgl[0] + "-" + ex_tgl[1];
            
            let expired = data.result.data_api.data_invoice.tgl_expired;
            let ex_tgl_expired = expired.split(' ');
            let tgl_expired = ex_tgl_expired[0];
           
            let set_hari_ini = new Date(hari_ini)
            let set_expired = new Date(tgl_expired)
  
            if(set_hari_ini.getTime() > set_expired.getTime()){
              // Kondisi expired
              this.setState({ 
                lisensi: false, 
              })
            }
            else{
              // Kondisi belum expired
              this.setState({ 
                lisensi: true, 
              })
            }
          }
  
          let paid = false
          if (data.result.pembayaran === 1) {
            paid = true
          }

          this.setState({
            paid,
            loading: false,
          })
          
          // For testing
          if (this.props.getPaidInfo) {
            this.props.getPaidInfo(data)
          }
        }
      // }
    })

    Get("pengaturan-aplikasi", null, dtkat => {
      if(dtkat.results){
        this.setState({
          konfigurasi_layanan_operator: dtkat.results.konfigurasi_layanan_operator,
          tampilGrafik: dtkat.results.jenis_dashboard,
        })

        if(dtkat.results.konfigurasi_layanan_operator === 'Konfigurasi Per Operator'){
          Get("pengguna/konfig-akses-surat/detail/list?id_pengguna=" + this.state.akun.sub.uuid, null, dtkat => {
            
            let layananSuratBaru = [];
            dtkat.results.forEach((dt) => {
              layananSuratBaru.push(dt.detail_jenis_surat.jenis_surat);
            });

            if(dtkat.results){
              this.setState({ 
                layananSuratBaru: layananSuratBaru, 
                layananSuratBaruPermanent: layananSuratBaru,  
                loadingListLayanan: false 
              });
            }
          });
        }
        else{
          Get("list-jenis-surat-main", null, lihat => {

            if(lihat.results){
              this.setState({ 
                layananSuratBaru: lihat.results,
                layananSuratBaruPermanent: lihat.results,
                loadingListLayanan: false,
              })
            }
            else{
              this.setState({ 
                loadingListLayanan: false,
              })  
            }
          });
        }

      }
      else{
        Get("list-jenis-surat-main", null, lihat => {

          if(lihat.results){
            this.setState({ 
              layananSuratBaru: lihat.results,
              layananSuratBaruPermanent: lihat.results,
              loadingListLayanan: false,
            })
          }
          else{
            this.setState({ 
              loadingListLayanan: false,
            })  
          }
        });
      }
    })
    
    Get("keldes/find/"+ID_DESA, null, lihat => {
      if(lihat.results){
        GetEksternal("pelayanan-instansi/desa/Kecamatan/"+ lihat.results.id_kecamatan + '/Kantor Camat', null, dtkat => {
          if (dtkat.results) {
            this.setState({ layananKecamatan: dtkat.results })
          }
        });
      }
    });

    Get("list-pengajuan-layanan/menunggu-eksekusi", null, dtkat => {
      if (this._isMounted) {
        if (dtkat.results) {
          this.setState({ jumlahMenungguEksekusi: dtkat.results.total });
        }
      }
    });

    Get("list-pengajuan-layanan/selesai", null, dtkat => {
      // if (this._isMounted) {
        if (dtkat.results) {
          if (this._isMounted) {
            this.setState({ jumlahSelesai: dtkat.results.total });
          }
        }
      // }
    });

    Get("pengaduan?status=Diajukan", null, dtkat => {
      // if (this._isMounted) {
        if (dtkat.results) {
          if (this._isMounted) {
            this.setState({ jumlahPengaduanDiajukan: dtkat.results.total });
          }
        }
      // }
    });

    Get("catatan-penduduk?status=0", null, dtkat => {
      // if (this._isMounted) {
        if (dtkat.results) {
          if (this._isMounted) {
            this.setState({ jumlahCatatanMenungguEksekusi: dtkat.results.total });
          }
        }
      // }
    });

    Get("pengguna?status=1", null, dtkat => {
      if (dtkat.results) {
        if (this._isMounted) {
          this.setState({
            jumlahVerifikasiMenungguEksekusi: dtkat.results.total
          });
        }
      }
    });

    Get("info-desa/berita", null, dtkat => {
      if(dtkat.results){
        this.setState({ dataBerita: dtkat.results.data});
      }
    })
    Get("profile-desa", null, dtkat => {
      if(dtkat.results){
        this.setState({ dataSetting: dtkat.results});
      }
    })

    this.getDataDetailGrafikStatistik(this.state.statistik_penduduk.jenis.value, 'grafik') 
    this.getDataGrafikPotensi()

    // Get jumlah penduduk
    Get('potensi-desa/jumlah-masyarakat', null, (data) => {

      var data_jenis_kelamin = [];
      var drilldown_jenis_kelamin = [];

      if (data.results) {
        let data_potensi_penduduk = {
          total: data.results.total,
          laki_laki: data.results.laki_laki,
          perempuan: data.results.perempuan
        };
        this.setState({ data_potensi_penduduk });
      }
    });

  }

  componentWillUnmount(){
    this._isMounted = false
  }

  openVersion = data => {
    this.setState({
      status: {
        ...this.state.status,
        modalVersion: true
      }
    })
  };

  onChangeSelect = (e, jenis, data_filter) => {
    if (e) {
      if(data_filter === 'jenis'){
        setTimeout(function () {
          this.getDataDetailGrafikStatistik(e.value, 'grafik')
        }.bind(this),1000)
      }

      this.setState({
        [jenis]: {
          ...this.state[jenis],
          [data_filter]: e
        }
      })
      
      if(data_filter === 'dusun' || data_filter === 'rw' || data_filter === 'rt'){
        if(this.state.active_tab_icon === '1'){
          setTimeout(function () {
            this.getDataDetailGrafikStatistik(this.state.statistik_penduduk.jenis.value, 'grafik') 
          }.bind(this),1000)
        }
        this.setState({
          loadingGrafikPotensi: true,
          loadingGrafik: true,
        })
        setTimeout(function () {
          this.getDataGrafikPotensi();
        }.bind(this),1000)
      }
    } else {
      if(data_filter === 'dusun'){
        this.state.frmRW = []
        this.state.frmRT = []
        this.state.statistik_penduduk.rw = null
        this.state.statistik_penduduk.rt = null
        this.forceUpdate();
        this.setState({
          loadingGrafikPotensi: true,
          loadingGrafik: true,
        })
        setTimeout(function () {
          this.getDataGrafikPotensi();
        }.bind(this),1000)
        if(this.state.active_tab_icon === '1'){
          setTimeout(function () {
            this.getDataDetailGrafikStatistik(this.state.statistik_penduduk.jenis.value, 'grafik') 
          }.bind(this),1000)
        }
      }
      else if(data_filter === 'rw'){
        this.state.frmRT = []
        this.state.statistik_penduduk.rt = null
        this.forceUpdate();
        this.setState({
          loadingGrafikPotensi: true,
          loadingGrafik: true,
        })
        setTimeout(function () {
          this.getDataGrafikPotensi();
        }.bind(this),1000)
        if(this.state.active_tab_icon === '1'){
          setTimeout(function () {
            this.getDataDetailGrafikStatistik(this.state.statistik_penduduk.jenis.value, 'grafik') 
          }.bind(this),1000)
        }
      }
      else if(data_filter === 'rt'){
        this.setState({
          loadingGrafikPotensi: true,
          loadingGrafik: true,
        })
        setTimeout(function () {
          this.getDataGrafikPotensi();
        }.bind(this),1000)
        if(this.state.active_tab_icon === '1'){
          setTimeout(function () {
            this.getDataDetailGrafikStatistik(this.state.statistik_penduduk.jenis.value, 'grafik') 
          }.bind(this),1000)
        }
      }
      
      this.setState({
        [jenis]: {
          ...this.state[jenis],
          [data_filter]: null
        }
      })
    }
  }

	getChild = (e, self, parent, child) => {
		this.onChangeSelect(e, 'statistik_penduduk', self);
		
		if (e) {
      this.state.status.select = true;
			Get(child + '/' + parent + '/' + e.value + '/list', null, (data) => {
				let frm = [];
				data.results.forEach((dt) => {
					frm.push({ value: dt.id, label: dt.nama });
				});
				switch (child) {
					case 'rw':
						this.setState({ frmRW: frm });
						break;

					case 'rt':
						this.setState({ frmRT: frm });
						break;
          default:
            // no default
            break;
				}
				this.state.status.select = false;
				this.forceUpdate();
			});
		}
	}

  changeView = (parent, mode) => {
    let set_mode = ''
    if(parent){
      if(mode === 'grafik'){
        set_mode = 'tabel'
      }
      else{
        set_mode = 'grafik'
      }

      this.setState({
        layananSuratBaru: this.state.layananSuratBaruPermanent,
        cariSurat: '',
        statistik_penduduk:{
          ...this.state.statistik_penduduk,
          mode: set_mode
        },
        active_tab_icon: '1',
      })
    }
    else{
      if(mode === 'Grafik'){
        set_mode = 'Pelayanan'
      }
      else{
        set_mode = 'Grafik'
      }
      
      this.setState({
        layananSuratBaru: this.state.layananSuratBaruPermanent,
        cariSurat: '',
        tampilGrafik: set_mode,
        active_tab_icon: '1',
      })
    }
  }

  fetchDetail = (params = {}) => {
    this.setState({
      loadingGrafik: true,
    })
    
		if (params.url) {
			Get(params.url, null, (dtkat) => {
        if(dtkat.results && dtkat.results[params.parent]){
          this.setState({ data_detail: dtkat.results[params.parent], loadingGrafik: false });
        }
        else{
          this.setState({ data_detail: [], loadingGrafik: false });
        }
			});
		}
	};

  getDataDetailGrafikStatistik = (table, jenis, url = null) => {
    let dusun = ''
    let rw = ''
    let rt = ''
    if(this.state.statistik_penduduk.dusun){
      dusun = this.state.statistik_penduduk.dusun.value
    }
    if(this.state.statistik_penduduk.rw){
      rw = this.state.statistik_penduduk.rw.value
    }
    if(this.state.statistik_penduduk.rt){
      rt = this.state.statistik_penduduk.rt.value
    }
    
    let filter = '?dusun=' + dusun + '&rw=' + rw + '&rt=' + rt

    let filterParent = "&parent="+table

    let urlDetail = 'statistik/data-statistik' + filter + filterParent;
    this.fetchDetail({ page: null, where: [], tab: '1', url: urlDetail, parent: table });

    this.forceUpdate()
	};

  // Grafik
  highchartSemiCircleDonutFunction = (data_chart, drilldown_chart, title_chart) => {
    const options = {
        chart: {
            plotBackgroundColor: null,
            plotBorderWidth: 0,
            plotShadow: false,
            type: 'pie'
        },
        title: {
            text: title_chart,
            align: 'center',
            verticalAlign: 'middle',
            y: 60,
            style: {
                fontSize: '1.1em'
            }
        },
        tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        accessibility: {
            point: {
                valueSuffix: '%'
            }
        },
        plotOptions: {
            pie: {
                dataLabels: {
                    enabled: true,
                    distance: -50,
                    style: {
                        fontWeight: 'bold',
                        color: 'white'
                    }
                },
                startAngle: -90,
                endAngle: 90,
                center: ['50%', '75%'],
                size: '110%'
            }
        },
        series: [{
            name: 'Total',
            innerSize: '50%',
            data: data_chart
        }],
        drilldown: {
            series: drilldown_chart
        }
    };
    return options;
  };

  highchartVariablePieFunction = (data_chart, title_chart, drilldown_chart) => {
    const options = {
        chart: {
            type: 'variablepie'
        },
        title: {
            text: title_chart,
            align: 'center'
        },
        tooltip: {
            headerFormat: '',
            pointFormat: '<span style="color:{point.color}">\u25CF</span> <b> ' +
                '{point.name}</b><br/>' +
                'Area (square km): <b>{point.y}</b><br/>' +
                'Population density (people per square km): <b>{point.z}</b><br/>'
        },
        series: [{
            minPointSize: 10,
            innerSize: '20%',
            zMin: 0,
            name: 'countries',
            borderRadius: 5,
            data: data_chart,
            colors: [
                '#4caefe',
                '#3dc3e8',
                '#2dd9db',
                '#1feeaf',
                '#0ff3a0',
                '#00e887',
                '#23e274'
            ]
        }],
        drilldown: {
          series: drilldown_chart
      }
    };
    return options;
  };

  highchartDonutFunction = (data_chart, drilldown_chart, title_chart) => {
		const options = {
			chart: {
				// plotBackgroundColor: null,
				// plotBorderWidth: 0,
				plotShadow: false,
				height: 400
			},
			credits: {
				enabled: false
			},
			accessibility: {
				announceNewData: {
					enabled: true
				},
				point: {
					valueSuffix: '%'
				}
			},
			tooltip: {
				pointFormat: '{series.name}: <b>{point.y} ({point.percentage:.1f}%)</b>'
			},
			plotOptions: {
				pie: {
					allowPointSelect: true,
					cursor: 'pointer',
					dataLabels: {
						enabled: true,
						alignTo: 'plotEdges',
						connectorPadding: 0,
						connectorShape: 'crookedLine',
						distance: 10,
						style: {
							fontSize: '12px'
						}
					}
				}
			},
			title: {
				text: title_chart,
				margin: 3,
				style: {
					fontSize: '13px',
					fontWeight: 'bold'
				},
				align: 'center'
			},
			legend: {
				enabled: true
			},
			series: [
				{
					name: 'Total',
					type: 'pie',
					innerSize: '60%',
					colorByPoint: true,
					data: data_chart
				}
			],
			drilldown: {
				series: drilldown_chart
			}
		};
		return options;
	};

  highchart3DPieFunction = (data_chart, title_chart) => {
    const options = {
      chart: {
        type: 'pie',
        options3d: {
          enabled: true,
          alpha: 45
        }
      },
      title: {
        text: title_chart,
        align: 'left'
      },
      plotOptions: {
        pie: {
          innerSize: 100,
          depth: 45
        }
      },
      series: [{
        name: 'Jumlah',
        data: data_chart
      }]
    };
    return options;
  };

  highchartPieFunction = (data_chart, drilldown_chart, title_chart) => {
		const options = {
			chart: {
				type: 'pie',
				height: 400
			},
			credits: {
				enabled: false
			},
			accessibility: {
				announceNewData: {
					enabled: true
				},
				point: {
					valueSuffix: '%'
				}
			},
			tooltip: {
				pointFormat: 'Total: <b>{point.y} ({point.percentage:.1f}%)</b>'
			},
			plotOptions: {
				pie: {
					allowPointSelect: true,
					cursor: 'pointer',
					dataLabels: {
						enabled: true,
						alignTo: 'plotEdges',
						connectorPadding: 0,
						connectorShape: 'crookedLine',
						distance: 20,
						overflow: 'allow',
						style: {
							fontSize: '12px'
						}
					}
					// showInLegend: true
				}
			},
			title: {
				text: title_chart,
				margin: 3,
				style: {
					fontSize: '13px',
					fontWeight: 'bold'
				}
			},
			legend: {
				enabled: true
			},
			series: [
				{
					name: 'previous',
					colorByPoint: true,
					data: data_chart
				}
			],
			drilldown: {
				series: drilldown_chart
			}
		};
		return options;
	};

  highchartColumnFunction = (data_chart, drilldown_chart, title_chart) => {
    const options = {
      chart: {
        type: 'column'
      },
      title: {
        text: title_chart,
        align: 'left'
      },
      xAxis: {
        type: 'category',
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Jumlah Penduduk'
        }
      },
      tooltip: {
        valueSuffix: ''
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0
        }
      },
      series: [{
        name: 'Jumlah',
        data: data_chart
      }],
      drilldown: {
				series: drilldown_chart
			},
    };
    return options;
  };

  // function kondisi get chart
  getChartOptions = (jenis) => {
    switch (jenis) {
      case 'pendidikan_warga':
        return this.highchart3DPieFunction(
          this.state.data_grafik_potensi.pendidikan_warga,
          this.state.drilldown_grafik_potensi.pendidikan_warga,
          'Data Pendidikan Masyarakat'
        );
      case 'rentang_usia':
        return this.highchartPieFunction(
          this.state.data_grafik_potensi.rentang_usia,
          this.state.drilldown_grafik_potensi.rentang_usia,
          'Data Rentang Umur Masyarakat'
        );
      case 'pekerjaan_warga':
        return this.highchartPieFunction(
          this.state.data_grafik_potensi.pekerjaan_warga,
          this.state.drilldown_grafik_potensi.pekerjaan_warga,
          'Data Pekerjaan Masyarakat'
        );
      case 'agama_warga':
        return this.highchartPieFunction(
          this.state.data_grafik_potensi.agama_warga,
          this.state.drilldown_grafik_potensi.agama_warga,
          'Data Agama Masyarakat'
        );
      case 'jenis_kelamin':
        return this.highchartPieFunction(
          this.state.data_grafik_potensi.jenis_kelamin,
          this.state.drilldown_grafik_potensi.jenis_kelamin,
          'Data Jenis Kelamin Masyarakat'
        );
      case 'golongan_darah_warga':
        return this.highchartPieFunction(
          this.state.data_grafik_potensi.golongan_darah_warga,
          this.state.drilldown_grafik_potensi.golongan_darah_warga,
          'Data Golongan Darah Masyarakat'
        );
      case 'bantuan_sosial':
        return this.highchartPotensiBar(
          this.state.data_grafik_potensi.bantuan_sosial,
          this.state.drilldown_grafik_potensi.bantuan_sosial,
          'single',
          ''
        );
    
      default:
        return {};
    }
  }

  // GRAFIK POTENSI
  getDataGrafikPotensi = () =>{

    this.setState({
      loadingGrafikPotensi: true,
      loadingGrafik: true,
    })

    let dusun = ''
    let rw = ''
    let rt = ''
    if(this.state.statistik_penduduk.dusun){
      dusun = this.state.statistik_penduduk.dusun.value
    }
    if(this.state.statistik_penduduk.rw){
      rw = this.state.statistik_penduduk.rw.value
    }
    if(this.state.statistik_penduduk.rt){
      rt = this.state.statistik_penduduk.rt.value
    }
    
    let filter = '?dusun=' + dusun + '&rw=' + rw + '&rt=' + rt


    Get('statistik/potensi-desa' + filter, null, (data) => {
      let data_graph = {};
      let drilldown_graph = []; // Fitur untuk detail
      let option_select = [];
      let data_graph_group = {};
      let drilldown_graph_group = []; // Fitur untuk detail

      if (data.results) {

        Object.keys(data.results).forEach((parent, index) => {
          if(Array.isArray(data.results[parent])){
            data_graph[parent] = []
            drilldown_graph[parent] = []
            option_select[parent] = []

            for (const index in data.results[parent]) {
              data_graph[parent].push({
                name: data.results[parent][index].nama,
                y: data.results[parent][index].data_penduduk_count,
                drilldown: data.results[parent][index].nama
              });
              option_select[parent].push({
                value: data.results[parent][index].uuid ? data.results[parent][index].uuid : data.results[parent][index].nama,
                label: data.results[parent][index].nama
              });
            }

            this.setState({
              data_grafik_potensi_dinamis:{
                ...this.state.data_grafik_potensi_dinamis,
                [parent]: data_graph[parent],
              },
              drilldown_grafik_potensi_dinamis:{
                ...this.state.drilldown_grafik_potensi_dinamis,
                [parent]: drilldown_graph[parent],
              },
              frmSelectGrafikPotensiDetail:{
                ...this.state.frmSelectGrafikPotensiDetail,
                [parent]: option_select[parent],
              }
            })
          }
          else{
            data_graph[parent] = []
            drilldown_graph[parent] = []
            option_select[parent] = []

            for (const index in data.results[parent].child) {
              data_graph[parent].push({
                name: data.results[parent].child[index].nama,
                y: data.results[parent].child[index].data_penduduk_count,
                drilldown: data.results[parent].child[index].nama
              });
              option_select[parent].push({
                value: data.results[parent].child[index].uuid ? data.results[parent].child[index].uuid : data.results[parent].child[index].nama,
                label: data.results[parent].child[index].nama
              });
            }

            this.setState({
              data_grafik_potensi_dinamis:{
                ...this.state.data_grafik_potensi_dinamis,
                [parent]: data_graph[parent],
              },
              drilldown_grafik_potensi_dinamis:{
                ...this.state.drilldown_grafik_potensi_dinamis,
                [parent]: drilldown_graph[parent],
              },
              frmSelectGrafikPotensiDetail:{
                ...this.state.frmSelectGrafikPotensiDetail,
                [parent]: option_select[parent],
              }
            })



            // =================== GROUP =====================
            data_graph_group['kesehatan'] = []
            drilldown_graph_group['kesehatan'] = []
            // KESEHATAN
            if (
              data.results[parent].nama.toLowerCase() === 'perilaku hidup bersih' ||
              data.results[parent].nama.toLowerCase() === 'pola makan keluarga' ||
              data.results[parent].nama.toLowerCase() === 'cakupan imunisasi'
            ) {
              data_graph_group['kesehatan_'+parent] = []
              drilldown_graph_group['kesehatan_'+parent] = []

              data_graph_group['kesehatan_'+parent] = {
                name: data.results[parent].nama,
                y: data.results[parent].data_penduduk_count,
                drilldown: data.results[parent].nama
              }
              // data_graph_group['kesehatan_'+parent].push({
              //   name: data.results[parent].nama,
              //   y: data.results[parent].data_penduduk_count,
              //   drilldown: data.results[parent].nama + index
              // })

              var sub_aset_pilihan = [];

              data.results[parent].child.map((aset_pilihan, key) => {
                sub_aset_pilihan.push([ aset_pilihan.nama, aset_pilihan.data_penduduk_count ]);
              })

              drilldown_graph_group['kesehatan_'+parent] = {
                id: data.results[parent].nama,
                name: 'Jumlah ',
                data: sub_aset_pilihan
              };
              // drilldown_graph_group['kesehatan_'+parent].push({
              //   id: data.results[parent].nama + index,
              //   name: 'Jumlah ',
              //   data: sub_aset_pilihan
              // });

              this.setState({
                data_grafik_potensi_group:{
                  ...this.state.data_grafik_potensi_group,
                  kesehatan:{
                    ...this.state.data_grafik_potensi_group.kesehatan,
                    [parent]: data_graph_group['kesehatan_'+parent],
                  }
                },
                drilldown_grafik_potensi_group:{
                  ...this.state.drilldown_grafik_potensi_group,
                  kesehatan: {
                    ...this.state.drilldown_grafik_potensi_group.kesehatan,
                    [parent]: drilldown_graph_group['kesehatan_'+parent],
                  }
                }
              })
            }
            // KESEHATAN

            this.setState({
              // data_grafik_potensi_group:{
              //   ...this.state.data_grafik_potensi_group,
              //   kesehatan: data_graph_group['kesehatan_'+parent],
              // },
              // drilldown_grafik_potensi_group:{
              //   ...this.state.drilldown_grafik_potensi_group,
              //   kesehatan: {
              //     ...this.state.drilldown_grafik_potensi_group.kesehatan,
              //     [parent]: drilldown_graph_group['kesehatan_'+parent],
              //   }
              // }
            })

            // =================== GROUP =====================
          }

        })
      }
    })
    Get('statistik/all' + filter, null, (data) => {
      let data_graph = {};
      let drilldown_graph = []; // Fitur untuk detail
      let option_select = [];

      if (data.results) {

        Object.keys(data.results).forEach((parent) => {
          if(Array.isArray(data.results[parent])){
            data_graph[parent] = []
            drilldown_graph[parent] = []
            option_select[parent] = []

            for (const index in data.results[parent]) {
              data_graph[parent].push({
                name: data.results[parent][index].nama,
                y: data.results[parent][index].data_penduduk_count,
                drilldown: data.results[parent][index].nama
              });
              
              option_select[parent].push({
								value: data.results[parent][index].uuid ? data.results[parent][index].uuid : data.results[parent][index].nama,
								label: data.results[parent][index].nama
							});
            }

            this.setState({
              data_grafik_potensi:{
                ...this.state.data_grafik_potensi,
                [parent]: data_graph[parent],
              },
              drilldown_grafik_potensi:{
                ...this.state.drilldown_grafik_potensi,
                [parent]: drilldown_graph[parent],
              },
              frmSelectGrafikPotensiDetail:{
                ...this.state.frmSelectGrafikPotensiDetail,
                [parent]: option_select[parent],
              }
            })
          }
          else{
            // console.log(parent)
          }
        })

        this.setState({
          loadingGrafikPotensi: false,
          loadingGrafik: false,
        })
      }
      else{
        this.setState({
          loadingGrafikPotensi: false,
          loadingGrafik: false,
        })
      }
    });
  }

  getChartOptionsPotensi = (parent, jenis, status_data, title) => {
    if(status_data === 'single'){
      if(this.state.data_grafik_potensi && this.state.data_grafik_potensi[parent]){
        switch (jenis) {
          case 'pie':
            return this.highchartPotensiPie(
              this.state.data_grafik_potensi[parent],
              this.state.drilldown_grafik_potensi[parent],
              status_data,
              title,
            );
          case 'donut':
            return this.highchartPotensiDonut(
              this.state.data_grafik_potensi[parent],
              this.state.drilldown_grafik_potensi[parent],
              status_data,
              title,
            );
          case 'pie-semi-circle':
            return this.highchartPotensiPieSemiCircle(
              this.state.data_grafik_potensi[parent],
              this.state.drilldown_grafik_potensi[parent],
              status_data,
              title,
            );
  
          case 'bar':
            return this.highchartPotensiBar(
              this.state.data_grafik_potensi[parent],
              this.state.drilldown_grafik_potensi[parent],
              status_data,
              title,
            );
  
          case 'bar-color':
            return this.highchartPotensiBarColor(
              this.state.data_grafik_potensi[parent],
              this.state.drilldown_grafik_potensi[parent],
              status_data,
              title,
            );
  
          default:
            return {};
        }
      }
      // Versi Dinamis
      else if(this.state.data_grafik_potensi_dinamis && this.state.data_grafik_potensi_dinamis[parent]){
        switch (jenis) {
          case 'pie':
            return this.highchartPotensiPie(
              this.state.data_grafik_potensi_dinamis[parent],
              this.state.drilldown_grafik_potensi_dinamis[parent],
              status_data,
              title,
            );
        }
      }
    }
    else if(status_data === 'group'){
      if(this.state.data_grafik_potensi_group && this.state.data_grafik_potensi_group[parent]){
        switch (jenis) {
          case 'pie':
            return this.highchartPotensiPie(
              this.state.data_grafik_potensi_group[parent],
              this.state.drilldown_grafik_potensi_group[parent],
              status_data,
              title,
            );
          case 'pie-semi-circle':
            return this.highchartPotensiPieSemiCircle(
              this.state.data_grafik_potensi_group[parent],
              this.state.drilldown_grafik_potensi_group[parent],
              status_data,
              title,
            );
          case 'bar-color':
            return this.highchartPotensiBarColor(
              this.state.data_grafik_potensi_group[parent],
              this.state.drilldown_grafik_potensi_group[parent],
              status_data,
              title,
            );
          case 'packed-bubble-split':
            return this.highchartPotensiPackedBubbleSplit(
              this.state.data_grafik_potensi_group[parent],
              this.state.drilldown_grafik_potensi_group[parent],
              status_data,
              title,
            );

          default:
            return {};
        }
      }
    }
  }

  highchartPotensiPie = (data_chart, title_chart, status_data, title) => {
    let options = {}
    if(status_data === 'single'){
      options = {
        chart: {
          type: 'pie',
          height: 280
        },
        credits: {
          enabled: false
        },
        accessibility: {
          announceNewData: {
            enabled: true
          },
          point: {
            valueSuffix: '%'
          }
        },
        tooltip: {
          pointFormat: 'Total: <b>{point.y} ({point.percentage:.1f}%)</b>'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              alignTo: 'plotEdges',
              connectorPadding: 0,
              connectorShape: 'crookedLine',
              distance: 20,
              overflow: 'allow',
              style: {
                fontSize: '9px'
              }
            }
            // showInLegend: true
          }
        },
        title: {
          text: title_chart,
          margin: 1,
          style: {
            fontSize: '13px',
            fontWeight: 'bold'
          }
        },
        legend: {
          enabled: true
        },
        series: [
          {
            name: 'previous',
            colorByPoint: true,
            data: data_chart
          }
        ],
      };
    }
    else if(status_data === 'group'){
      let drilldown_chart = Object.values(title_chart)
      let newData = Object.values(data_chart)
      
      options = {
        chart: {
          type: 'pie',
          height: 280
        },
        credits: {
          enabled: false
        },
        accessibility: {
          announceNewData: {
            enabled: true
          },
          point: {
            valueSuffix: '%'
          }
        },
        tooltip: {
          pointFormat: 'Total: <b>{point.y} ({point.percentage:.1f}%)</b>'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              alignTo: 'plotEdges',
              connectorPadding: 0,
              connectorShape: 'crookedLine',
              distance: 20,
              overflow: 'allow',
              style: {
                fontSize: '9px'
              }
            }
            // showInLegend: true
          }
        },
        title: {
          text: '',
          margin: 3,
        },
        legend: {
          enabled: true
        },
        series: [
          {
            name: 'previous',
            colorByPoint: true,
            data: newData
          }
        ],
        drilldown: {
          series: drilldown_chart
        }
      };
    }
		return options;
  };

  highchartPotensiDonut = (data_chart, title_chart, status_data, title) => {
    let options = {}
    if(status_data === 'single'){
      let total = 0;

      data_chart.forEach(dt => {
        total = total + dt.y
      });

      options = {
        chart: {
          type: 'pie',
          height: 280,
          custom: {},
          events: {
            render() {
              const chart = this,
              series = chart.series[0];
              let customLabel = chart.options.chart.custom.label;

              if (!customLabel) {
                customLabel = chart.options.chart.custom.label =
                    chart.renderer.label(
                        'Total<br/>' +
                        '<strong>'+ total +'</strong>'
                    )
                    .css({
                        color: '#000',
                        textAnchor: 'middle'
                    })
                    .add();
              }

              const x = series.center[0] + chart.plotLeft,
                  y = series.center[1] + chart.plotTop - (customLabel.attr('height') / 2);

              customLabel.attr({
                x,
                y
              });
              // Set font size based on chart diameter
              customLabel.css({
                fontSize: `${series.center[2] / 12}px`
              });
            }
          }
        },
        credits: {
          enabled: false
        },
        accessibility: {
          announceNewData: {
            enabled: true
          },
          point: {
            valueSuffix: '%'
          }
        },
        tooltip: {
          pointFormat: 'Total: <b>{point.y} ({point.percentage:.1f}%)</b>'
        },
        plotOptions: {
          series: {
            allowPointSelect: true,
            cursor: 'pointer',
            borderRadius: 8,
            dataLabels: [{
              enabled: true,
              distance: 20,
              format: '{point.name}'
            }, {
              enabled: true,
              distance: -15,
              format: '{point.percentage:.0f}%',
              style: {
                fontSize: '0.9em'
              }
            }],
            showInLegend: true
          }
        },
        title: {
          text: title_chart,
          margin: 1,
          style: {
            fontSize: '13px',
            fontWeight: 'bold'
          }
        },
        legend: {
          enabled: true
        },
        series: [
          {
            innerSize: '75%',
            name: 'previous',
            colorByPoint: true,
            data: data_chart
          }
        ],
      };
    }
		return options;
  };
  
  highchartPotensiPieSemiCircle = (data_chart, title_chart, status_data, title) => {
    let options = {}
    if(status_data === 'single'){
      options = {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: 0,
          plotShadow: false,
          height: 280
        },
        credits: {
          enabled: false
        },
        accessibility: {
          announceNewData: {
            enabled: true
          },
          point: {
            valueSuffix: '%'
          }
        },
        tooltip: {
          pointFormat: 'Total: <b>{point.y} ({point.percentage:.1f}%)</b>'
        },
        plotOptions: {
          pie: {
            dataLabels: {
                enabled: true,
                distance: -50,
                style: {
                    fontWeight: 'bold',
                    color: 'white'
                }
            },
            startAngle: -90,
            endAngle: 90,
            center: ['50%', '75%'],
            size: '110%'
          }
        },
        title: {
          text: title_chart,
          margin: 1,
          style: {
            fontSize: '13px',
            fontWeight: 'bold'
          }
        },
        legend: {
          enabled: true
        },
        series: [
          {
            type: 'pie',
            innerSize: '50%',
            name: 'previous',
            colorByPoint: true,
            data: data_chart
          }
        ],
      };
    }
    else if(status_data === 'group'){
      let drilldown_chart = Object.values(title_chart)
      let newData = Object.values(data_chart)

      options = {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: 0,
          plotShadow: false,
          height: 280
        },
        credits: {
          enabled: false
        },
        accessibility: {
          announceNewData: {
            enabled: true
          },
          point: {
            valueSuffix: '%'
          }
        },
        tooltip: {
          pointFormat: 'Total: <b>{point.y} ({point.percentage:.1f}%)</b>'
        },
        plotOptions: {
          pie: {
            dataLabels: {
                enabled: true,
                distance: -50,
                style: {
                    fontWeight: 'bold',
                    color: 'white'
                }
            },
            startAngle: -90,
            endAngle: 90,
            center: ['50%', '75%'],
            size: '110%'
          }
        },
        title: {
          text: title_chart,
          margin: 1,
          style: {
            fontSize: '13px',
            fontWeight: 'bold'
          }
        },
        legend: {
          enabled: true
        },
        series: [
          {
            type: 'pie',
            innerSize: '50%',
            name: 'previous',
            colorByPoint: true,
            data: newData
          }
        ],
        drilldown: {
          series: drilldown_chart
        }
      };
    }
		return options;
  };

  highchartPotensiBar = (data_chart, title_chart, status_data, title) => {
    let options = {}
    if(status_data === 'single'){
      let xAxisBar = []

      data_chart.forEach(dt => {
        xAxisBar.push(dt.name);
      });

      options = {
        chart: {
          type: 'column',
          height: 280
        },
        credits: {
          enabled: false
        },
        accessibility: {
          announceNewData: {
            enabled: true
          },
          point: {
            valueSuffix: '%'
          }
        },
        // tooltip: {
        //   pointFormat: 'Total: <b>{point.y} ({point.percentage:.1f}%)</b>'
        // },
        xAxis: {
          categories: xAxisBar,
          crosshair: true,
          accessibility: {
              description: title
          }
        },
        yAxis: {
          min: 0,
          title: {
              text: 'Jumlah Orang'
          }
        },
        plotOptions: {
          column: {
              pointPadding: 0.2,
              borderWidth: 0
          }
        },
        title: {
          text: title_chart,
          margin: 1,
          style: {
            fontSize: '13px',
            fontWeight: 'bold'
          }
        },
        legend: {
          enabled: false
        },
        series: [
          {
            name: '',
            colorByPoint: true,
            data: data_chart
          }
        ],
      };
    }
    else if(status_data === 'group'){
      let xAxisBar = []
      let dataBar = []

      let drilldown_chart = Object.values(title_chart)
      let newData = Object.values(data_chart)

      newData.forEach((dt, index) => {
        xAxisBar.push(dt.name);
        dataBar.push(dt.y);
      })

      options = {
        chart: {
          type: 'column',
          height: 280
        },
        title: {
            align: 'left',
            text: ''
        },
        accessibility: {
          announceNewData: {
            enabled: true
          },
          point: {
            valueSuffix: '%'
          }
        },
        tooltip: {
          pointFormat: 'Total: <b>{point.y} ({point.percentage:.1f}%)</b>'
        },
        xAxis: {
            type: 'category'
        },
        yAxis: {
            title: {
                text: 'Jumlah Orang'
            }
    
        },
        legend: {
            enabled: false
        },
        plotOptions: {
            series: {
                borderWidth: 0,
                dataLabels: {
                    enabled: true,
                    format: '{point.y:.1f}%'
                }
            }
        },
        series: [
            {
                name: '',
                colorByPoint: true,
                data: newData
            }
        ],
        drilldown: {
          breadcrumbs: {
              position: {
                  align: 'right'
              }
          },
          series: drilldown_chart
        }
      };
    }
		return options;
  };

  highchartPotensiBarColor = (data_chart, title_chart, status_data, title) => {
    let options = {}
    if(status_data === 'single'){
      let colorsBar = [
        '#4caefe',
        '#3fbdf3',
        '#35c3e8',
        '#2bc9dc',
        '#20cfe1',
        '#16d4e6',
        '#0dd9db',
        '#03dfd0',
        '#00e4c5',
        '#00e9ba',
        '#00eeaf',
        '#23e274'
      ]
      let xAxisBar = []
      let dataBar = []

      data_chart.forEach(dt => {
        xAxisBar.push(dt.name);
        dataBar.push(dt.y);
      });

      options = {
        chart: {
          type: 'pie',
          height: 280
        },
        credits: {
          enabled: false
        },
        colors: colorsBar,
        xAxis: {
          categories: xAxisBar,
        },
        yAxis: {
          min: 0,
          title: {
              text: 'Jumah ' + title,
          }
        },
        series: [{
          type: 'column',
          name: title,
          borderRadius: 5,
          colorByPoint: true,
          data: dataBar,
          showInLegend: false
        }],
        title: {
          text: title_chart,
          margin: 1,
          style: {
            fontSize: '13px',
            fontWeight: 'bold'
          }
        },
        legend: {
          enabled: true
        },
      };
    }
    else if(status_data === 'group'){
      let xAxisBar = []
      let dataBar = []

      let drilldown_chart = Object.values(title_chart)
      let newData = Object.values(data_chart)

      newData.forEach((dt, index) => {
        xAxisBar.push(dt.name);
        dataBar.push(dt.y);
      })

      options = {
        chart: {
          type: 'column',
          height: 280
        },
        title: {
            align: 'left',
            text: ''
        },
        accessibility: {
          announceNewData: {
            enabled: true
          },
          point: {
            valueSuffix: '%'
          }
        },
        tooltip: {
          pointFormat: 'Total: <b>{point.y} ({point.percentage:.1f}%)</b>'
        },
        xAxis: {
            type: 'category'
        },
        yAxis: {
            title: {
                text: 'Jumlah Orang'
            }
    
        },
        legend: {
            enabled: false
        },
        plotOptions: {
            series: {
                borderWidth: 0,
                dataLabels: {
                    enabled: true,
                    format: '{point.y:.1f}%'
                }
            }
        },    
        series: [
            {
                name: '',
                colorByPoint: true,
                data: newData
            }
        ],
        drilldown: {
          breadcrumbs: {
              position: {
                  align: 'right'
              }
          },
          series: drilldown_chart
        }
      };
    }
		return options;
  };

  getDataDetailGrafik = (table, jenis, url = null) => {

    let dusun = ''
    let rw = ''
    let rt = ''
    if(this.state.statistik_penduduk.dusun){
      dusun = this.state.statistik_penduduk.dusun.value
    }
    if(this.state.statistik_penduduk.rw){
      rw = this.state.statistik_penduduk.rw.value
    }
    if(this.state.statistik_penduduk.rt){
      rt = this.state.statistik_penduduk.rt.value
    }
    
    let filter = '?dusun=' + dusun + '&rw=' + rw + '&rt=' + rt

    let filterParent = "&parent="+table

    this.state.parentDetailPotensi = table

    let filterParentDetail = ''
    if(this.state.filterGrafikPotensiDetail){
      filterParentDetail = '&uuid_parent='+this.state.filterGrafikPotensiDetail.value
    }

    let pencarianParentDetail = ''
    if(this.state.cariGrafikPotensiDetail){
      pencarianParentDetail = '&q='+this.state.cariGrafikPotensiDetail
    }

    let urlDetailPotensi = 'statistik/data-potensi'+filter+filterParent+filterParentDetail+pencarianParentDetail;

    this.fetchDetailGrafikPotensi({ page: null, where: [], tab: '1', url: urlDetailPotensi, table: table });
    
    this.setState({
      status:{
        ...this.state.status,
        modalDetailGrafik: true,
      }
    })

    this.forceUpdate()
	};

	tutupModal = () => {
    this.setState({
      status:{
        ...this.state.status,
        modalDetailGrafik: false,
      },
      title: '',
      parentDetailPotensi: '',
      data_detail_grafik_potensi: [],
      filterGrafikPotensiDetail: null,
      cariGrafikPotensiDetail: '',
    })

		this.forceUpdate();
	};


  fetchDetailGrafikPotensi = (params = {}) => {
    this.setState({
      loadingGrafikPotensiDetail: true,
    })
		let link = '';
	
		if (params.page) {
			switch (params.page) {
				case '>>':
					if(this.state.urlPartDetail==="")
					{
						if(this.state.urlCariGrafikPotensi===""){
							link = '?page=' + Math.ceil(this.state.paginationDetailGrafikPotensi.total / this.state.paginationDetailGrafikPotensi.per_page);
						}
						else{
							link = '&page=' + Math.ceil(this.state.paginationDetailGrafikPotensi.total / this.state.paginationDetailGrafikPotensi.per_page);
						}
					}
					else{
						link = '&page=' + Math.ceil(this.state.paginationDetailGrafikPotensi.total / this.state.paginationDetailGrafikPotensi.per_page);
					}
					break;
				case '>':
					if(this.state.urlPartDetail==="")
					{
						if(this.state.urlCariGrafikPotensi===""){
							link = '?page=' + (parseInt(this.state.paginationDetailGrafikPotensi.current_page) + 1);
						}
						else{
							link = '&page=' + (parseInt(this.state.paginationDetailGrafikPotensi.current_page) + 1);
						}
					}
					else{
						link = '&page=' + (parseInt(this.state.paginationDetailGrafikPotensi.current_page) + 1);
					}
					break;
				case '<':
					if(this.state.urlPartDetail==="")
					{
						if(this.state.urlCariGrafikPotensi===""){
							link = '?page=' + (parseInt(this.state.paginationDetailGrafikPotensi.current_page) - 1);
						}
						else{
							link = '&page=' + (parseInt(this.state.paginationDetailGrafikPotensi.current_page) - 1);
						}
					}
					else{
						link = '&page=' + (parseInt(this.state.paginationDetailGrafikPotensi.current_page) - 1);
					}
					break;
				case '<<':
					if(this.state.urlPartDetail==="")
					{
						if(this.state.urlCariGrafikPotensi===""){
							link = '?page=1';
						}
						else{
							link = '&page=1';
						}
					}
					else{
						link = '&page=1';
					}
					break;
				default:
					if(this.state.urlPartDetail==="")
					{
						if(this.state.urlCariGrafikPotensi===""){
							link = '?page=' + params.page;
						}
						else{
							link = '&page=' + params.page;
						}
					}
					else{
						link = '&page=' + params.page;
					}
					break;
			}
		}

		if (params.url) {
			Get(params.url + link, null, (dtkat) => {
        if(dtkat.results){
          this.setState({ data_detail_grafik_potensi: dtkat.results.data, paginationDetailGrafikPotensi: dtkat.results, loadingGrafikPotensiDetail: false });
          this.paginationDetailGrafikPotensi(dtkat.results, params.url, params.table);
        }
        else{
          this.setState({ loadingGrafikPotensiDetail: false });
        }
			});
		}
	};

  paginationDetailGrafikPotensi = (data, urlDetail, table) => {
		let awalDetailGrafikPotensi = '';
		let halDetailGrafikPotensi = [];
		let sebelumDetailGrafikPotensi = '';
		let setelahDetailGrafikPotensi = '';
		let akhirDetailGrafikPotensi = '';

		if (data.total > 0) {
			let start = 1;
			let end = 5;
			let n = 0;
			let p = 0;
			if (data.current_page <= 3) {
				start = 1;
				end = 5;
				if (data.last_page > data.current_page) {
					n = data.current_page + 1;
				}
			} else {
				p = data.current_page - 1;
				n = data.current_page + 1;
				start = data.current_page - 2;
				end = data.current_page + 2;
			}
			if (end >= data.last_page - 2) {
				p = data.current_page - 1;
				if (start >= 5) {
					start = data.last_page - 4;
				}
				end = data.last_page;
			}

			for (let i = start; i <= end; i++) {
				let warna = 'success';
				if (i === data.current_page) {
					warna = 'danger';
				}
				halDetailGrafikPotensi.push(
					<a
						href={() => false}
						key={i}
						onClick={() => this.fetchDetailGrafikPotensi({ page: i, url: urlDetail, table: table })}
						className={'btn btn-' + warna + ' btn-square btn-sm pr-3 pl-3 pt-2 pb-2'}
					>
						{i}
					</a>
				);
			}
			if (p > 0) {
				sebelumDetailGrafikPotensi = (
					<a
						href={() => false}
						onClick={() => this.fetchDetailGrafikPotensi({ page: p, url: urlDetail, table: table })}
						className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
					>
						{'<'}
					</a>
				);
			}
			if (n > 0) {
				setelahDetailGrafikPotensi = (
					<a
						href={() => false}
						onClick={() => this.fetchDetailGrafikPotensi({ page: n, url: urlDetail, table: table })}
						className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
					>
						{'>'}
					</a>
				);
			}
			awalDetailGrafikPotensi = (
				<a
					href={() => false}
					onClick={() => this.fetchDetailGrafikPotensi({ page: 1, url: urlDetail, table: table })}
					className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
				>
					{'<<'}
				</a>
			);
			akhirDetailGrafikPotensi = (
				<a
					href={() => false}
					onClick={() => this.fetchDetailGrafikPotensi({ page: data.last_page, url: urlDetail, table: table })}
					className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
				>
					{'>>'}
				</a>
			);
		}
		this.setState({ awalDetailGrafikPotensi, sebelumDetailGrafikPotensi, halDetailGrafikPotensi, setelahDetailGrafikPotensi, akhirDetailGrafikPotensi });
	};

	cariDetailGrafikPotensi = (e, parent) => {
    if (e.key === 'Enter') {

      this.state.cariGrafikPotensiDetail = e.target.value
			this.forceUpdate();
      
      this.getDataDetailGrafik(parent, 'potensi');
		}
	};

  prosesExport = (e) => {
    e.preventDefault();

    this.setState({ 
			loadingPreview: true,
      status:{
        ...this.state.status,
        modalExport: false,
      },
		})
    
    let dusun = ''
    let rw = ''
    let rt = ''
    
    if(this.state.statistik_penduduk.dusun){
      dusun = this.state.statistik_penduduk.dusun.value
    }
    if(this.state.statistik_penduduk.rw){
      rw = this.state.statistik_penduduk.rw.value
    }
    if(this.state.statistik_penduduk.rt){
      rt = this.state.statistik_penduduk.rt.value
    }
    
    let filter = '?dusun=' + dusun + '&rw=' + rw + '&rt=' + rt

    let filterParent = "&parent="+this.state.statistik_penduduk.jenis.value

    let uuidPengguna = "&uuid_pengguna=" + this.state.akun.sub.uuid

    let email = "&email="+document.getElementById('email').value;
    
    let typeExport = "&type=" + this.state.jenisDokumen;
    
    let urlExport = 'statistik/export' + filter + filterParent + typeExport + uuidPengguna + email;

    Get(urlExport, null, dtkat => {
      console.log('respon export')
      console.log(dtkat)
      
      if (dtkat.code === 200) {
        this.setState({
          loadingPreview: false,
          jenisDokumen: '',
          show: true,
          basicType: 'success',
          basicTitle: 'Export Data',
          pesanAlert: 'Data export berhasil dikirim ke email anda'
        });
      }
      else{
        this.setState({
          loadingPreview: false,
          jenisDokumen: '',
          show: true,
          basicType: 'danger',
          basicTitle: 'Export Data',
          pesanAlert: 'Data export gagal dikirim ke email anda'
        });
      }
    })
  }

  // CARI DATA SURAT
  cariLayanan = (e) => {
    if (e.key === 'Enter') {
      this.setState({
        loadingListLayanan: true,
      })

      let filterData = this.state.layananSuratBaruPermanent.filter(dt => dt.nama_surat.toLowerCase().includes(e.target.value.toLowerCase()));;

      this.setState({
        layananSuratBaru: filterData,
        cariSurat: e.target.value
      })

      setTimeout(
        function() {
          this.setState({
            loadingListLayanan: false,
          })
        }.bind(this),
        500
      );
    }
  };

  // FETCH DATA
  fetchSuratMasuk = (params = {}) => {
    this.setState({ loadingSuratMasuk: true })

    let link = "";
    if (params.page) {
      switch (params.page) {
        case ">>":
          link =
            "?page=" +
            Math.ceil(
              this.state.paginationSuratMasuk.total / this.state.paginationSuratMasuk.per_page
            );
          break;
        case ">":
          link = "?page=" + (parseInt(this.state.paginationSuratMasuk.current_page) + 1);
          break;
        case "<":
          link = "?page=" + (parseInt(this.state.paginationSuratMasuk.current_page) - 1);
          break;
        case "<<":
          link = "?page=1";
          break;
        default:
          link = "?page=" + params.page;
          break;
      }
    }
    
    let setLink = '';
		if (link) {
			setLink = `${link}&q=${this.state.dataCariSuratMasuk.q}`
		}
		else {
			setLink = `?q=${this.state.dataCariSuratMasuk.q}`
		}

    Get("surat-masuk" + setLink, null, dtkat => {
      if (this._isMounted) {
        console.log('test');
        console.log(dtkat);
        this.setState({ 
          dataSuratMasuk: dtkat.results.data, 
          paginationSuratMasuk: dtkat.results,
          loadingSuratMasuk: false,
          totalSuratMasuk: dtkat.results.total 
        });

        this.paginationSuratMasuk(dtkat.results);
      }
    });
  };
  // END FETCH DATA

  // PAGINATION
  paginationSuratMasuk = data => {
    let awalSuratMasuk = "";
    let halSuratMasuk = [];
    let sebelumSuratMasuk = "";
    let setelahSuratMasuk = "";
    let akhirSuratMasuk = "";
    if (data.total > 0) {
      let start = 1;
      let end = 5;
      let n = 0;
      let p = 0;
      if (data.current_page <= 3) {
        start = 1;
        end = 5;
        if (data.last_page > data.current_page) {
          n = data.current_page + 1;
        }
      } else {
        p = data.current_page - 1;
        n = data.current_page + 1;
        start = data.current_page - 2;
        end = data.current_page + 2;
      }
      if (end >= data.last_page - 2) {
        p = data.current_page - 1;
        if (start >= 5) {
          start = data.last_page - 4;
        }
        end = data.last_page;
      }

      for (let i = start; i <= end; i++) {
        let warna = "primary-custom";
        if (i === data.current_page) {
          warna = "danger";
        }
        halSuratMasuk.push(
          <a
            href={() => false}
            onClick={() => this.fetchSuratMasuk({ page: i })}
            className={
              "btn btn-" + warna + " btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
            }
          >
            {i}
          </a>
        );
      }
      if (p > 0) {
        sebelumSuratMasuk = (
          <a
            href={() => false}
            onClick={() => this.fetchSuratMasuk({ page: p })}
            className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
          >
            {"<"}
          </a>
        );
      }
      if (n > 0) {
        setelahSuratMasuk = (
          <a
            href={() => false}
            onClick={() => this.fetchSuratMasuk({ page: n })}
            className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
          >
            {">"}
          </a>
        );
      }
      awalSuratMasuk = (
        <a
          href={() => false}
          onClick={() => this.fetchSuratMasuk({ page: 1 })}
          className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
        >
          {"<<"}
        </a>
      );
      akhirSuratMasuk = (
        <a
          href={() => false}
          onClick={() => this.fetchSuratMasuk({ page: data.last_page })}
          className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
        >
          {">>"}
        </a>
      );
    }
    this.setState({ awalSuratMasuk, sebelumSuratMasuk, halSuratMasuk, setelahSuratMasuk, akhirSuratMasuk });
  };
  // END PAGINATION
  // CARI DATA
  cariDataSuratMasuk = e => {
    if (e.key === 'Enter') {
      let dataCariSuratMasuk = {
				q: e.target.value
			};
			this.setState({ dataCariSuratMasuk });

      setTimeout(
        function() {
          this.fetchSuratMasuk({ page: null, where: [] });
        }.bind(this),
        500
      );
    }
  }

  bukaFormSuratMasuk = () => {
    this.setState({
      statusSuratMasuk:{
          ...this.state.statusSuratMasuk,
          form: true,
      },
      judul: "Tambah Data Surat Masuk",
      fileSuratMasuk: '',
    })
    this.forceUpdate();
  };

  tutupFormSuratMasuk = () => {
    this.setState({
        statusSuratMasuk:{
          ...this.state.statusSuratMasuk,
          form: false,
        },
      })
    this.forceUpdate();
  };
  
  handleChangeInputText = (e, parent) => {
		this.setState({
			dt:{
				...this.state.dt,
				[parent]: e.target.value
			}
		})
		this.forceUpdate();
	};

  gantiTgl = (e) => {
		if (typeof e.isValid !== 'undefined' && e._isValid) {
      this.setState({ dt : {
        ...this.state.dt,
        tanggal_masuk : e.format('YYYY/MM/DD')
      } })
    } else {
      this.setState({
        show: true,
        basicType: 'warning',
        basicTitle: 'Perhatian',
        pesanAlert: 'Isi data tanggal dengan benar',
        dt: {
          ...this.state.dt, 
          tanggal_masuk: new Date()
        }
      });
    }
	};

  // ========================= upload file ==================================
  processGbr = (d) => {
    // //console.log(d[0].type);
    if (d.length === 1) {
      const tipefile = [
        "jpg", "jpeg", "png", "bmp", "tiff", "webp",
        "pdf", "doc", "docx", "xlsx", "xls"
      ];
      this.setState({ loadingSuratMasuk: true });
      let type = d[0].type.split("/");
      
      if (tipefile.includes(type[1]) || d[0].name.endsWith(".xlsx") || d[0].name.endsWith(".xls") || d[0].name.endsWith(".doc") || d[0].name.endsWith(".docx")) {
        let bodyFormData = new FormData();
        bodyFormData.append("file", d[0]);
        bodyFormData.append("sub_folder", "Surat Masuk");

        Post("upload-file/google-drive", null, bodyFormData, (data) => {
          // console.log(data);
          this.setState({
            link_gambar: data.data.results,
            fileSuratMasuk: d[0].name,
            loadingSuratMasuk: false
          });
        },
        {
          "Content-Type": "multipart/form-data",
        }
      );
      } else {
        this.setState({
          loadingSuratMasuk: false,
          link_gambar: "",
          fileSuratMasuk: (
            <div className="text-danger font-size-10">
              Type file tidak valid
            </div>
          ),

          show: true,
          basicType: "danger",
          basicTitle: "Upload File",
          pesanAlert: "Format file tidak sesuai"
        });
      }
    } else {
      this.setState({
        link_gambar: "",
        fileSuratMasuk: (
          <div className="text-danger font-size-10">
            Silahkan masukan satu gambar atau dokumen
          </div>
        ),
      });
    }
  };
  // ========================================================================

  // ============================= simpan data surat masuk ==================
  simpan = e => {
    e.preventDefault();

		this.setState({ loadingPreview: true });

      if(this.state.link_gambar || (this.state.dt.uuid && this.state.dt.file)){
        let bodyData = {
          uuid: this.state.dt.uuid,
          nomor_surat: this.state.dt.nomor_surat,
          uraian_singkat: this.state.dt.uraian_singkat,
          dari: this.state.dt.dari,
          tujuan_surat: this.state.dt.tujuan_surat,
          perihal: this.state.dt.perihal,
          tanggal_masuk: this.state.dt.tanggal_masuk,
          keterangan: this.state.dt.keterangan,
          file: this.state.link_gambar,
          file_lama : this.state.dt.file,
        }
      
        let psn = "";
        let resstat = 204;
        let metode = "store";
        if (bodyData.uuid === "") {
          psn = "tambah";
          resstat = 201;
          bodyData.uuid = null;
        } else {
          psn = "ubah";
          resstat = 200;
          metode = "update";
        }
  
        Post('surat-masuk/' + metode, bodyData.uuid, bodyData, res => {
          if (res.status === resstat) {
            this.setState({
              loadingPreview: false,
              show: true,
              basicType: "success",
              basicTitle: "Data Surat Masuk "+JENIS_DESA,
              pesanAlert: "Berhasil " + psn + " Data",
              dt: frmInput,
              statusSuratMasuk: {
                ...this.state.statusSuratMasuk,
                form: false
              }
            });
          } else {
            this.setState({
              loadingPreview: false,
              show: true,
              basicType: "danger",
              basicTitle: "Data Surat Masuk "+JENIS_DESA,
              pesanAlert: "Gagal " + psn + " Data"
            });
          }
  
          this.componentDidMount();
        })
      }
      else{
        this.setState({
          loadingPreview: false,
          show: true,
          basicType: "danger",
          basicTitle: "Data Surat Masuk "+JENIS_DESA,
          pesanAlert: "Data Harus Lengkap!"
        });
      }
  };
  // ========================================================================

  // =========================== ubah data surat masuk ======================
  ubahData = data => {
		this.setState({
			judul: "Ubah Data Surat Masuk "+JENIS_DESA,
      loadingPreview: true,
		})

    if (data) {
			this.setState({
        link_gambar: JSON.parse(data.file),
				dt: {
					uuid: data.uuid,
          nomor_surat: data.nomor_surat,
					uraian_singkat: data.uraian_singkat,
					dari: data.dari,
					tujuan_surat: data.tujuan_surat,
					perihal: data.perihal,
					tanggal_masuk: new Date(data.tanggal_masuk),
					keterangan: data.keterangan,
					file: JSON.parse(data.file),
				},
				statusSuratMasuk: {
					...this.state.statusSuratMasuk,
					form: true
				},
        loadingPreview: false,
			})
		}
    else{
      this.setState({
        loadingPreview: false,
      })
    }
  };
  // ========================================================================

  konfirmHapus = id => {
    this.setState({
      alert: (
        <SweetAlert
          showCancel
          confirmBtnText="Hapus"
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="success"
          type="danger"
          title="Yakin ingin hapus data ?"
          onCancel={this.hideAlert}
          onConfirm={() => this.hapusData(id)}
        >
          Proses ini tidak dapat dibatalkan!
        </SweetAlert>
      )
    });
  };

  hapusData = id => {
    this.hideAlert();
    let psn = "Hapus";
    this.setState({
      loadingPreview: true,
    })
    Delete("surat-masuk/delete", id, res => {
      if (res === 200) {
        this.setState({
          loadingPreview: false,
          show: true,
          basicType: "success",
          basicTitle: "Data Surat Masuk",
          pesanAlert: "Berhasil " + psn + " Data"
        });
      } else {
        this.setState({
          loadingPreview: false,
          show: true,
          basicType: "danger",
          basicTitle: "Data Surat Masuk",
          pesanAlert: "Gagal " + psn + " Data"
        });
      }
      this.componentDidMount();
    });
  };

  tombolAksi = (cell, row) => {
    return (
      <div>
        <Button
          size="xs"
          color="success"
          className="btn-icon mr-1"
          onClick={() => this.ubahData(row)}
          disabled={this.state.statusSuratMasuk.btnAksi}
          >
          <i className="fa fa-pencil"></i>
        </Button>
        <Button
          size="xs"
          color="danger"
          className="btn-icon"
          onClick={() => {
            this.setState({
              judul: "Hapus Jenis Surat",
              statReset: false
            });
            this.konfirmHapus(row.uuid)
          }}
          disabled={this.state.statusSuratMasuk.btnAksi}
          >
          <i className="fa fa-trash"></i>
        </Button>
      </div>
    );
  };

  render() {

    const contact_person = contactPerson()

    // jika yg login administrasi
    if (this.state.akun && this.state.akun.sub && this.state.akun.sub.data_role) {
      // do nothing
    } else {
      return <Redirect to="/wisata/dashboard" push={true} />;
    }

    var data_detail = this.state.data_detail;
    var data_detail_grafik_potensi = this.state.data_detail_grafik_potensi;

    const Highcharts = require('highcharts/highstock');
		drilldown(Highcharts);

    // Dashboard Statistik Penduduk
    const columns = [
      {
      dataField: "no",
				text: "No",
				headerAlign: 'center',
				align: 'center',
        style: {
          width: '50px'
        },
				formatter: (key, obj, index) =>{    
          return index + 1;
				}
      },
      {
        dataField: 'nama',
        text: 'Kelompok',
        style: {
          width: '400px'
        },
        sort: true
      },
      {
          dataField: 'data_penduduk_count',
          text: 'Jumlah n',
          sort: true,
          headerAlign: 'center',
          align: 'center'
      },
      {
          dataField: 'jumlah_persen',
          text: 'Jumlah %',
          sort: true,
          headerAlign: 'center',
          align: 'center',
          formatter: (key, obj, index) =>{    
            var num = Number(obj.total_persen) // The Number() only visualizes the type and is not needed
            var roundedString = num.toFixed(2);
            let tampil = Number(roundedString)
            
            return tampil+'%';
          }
      },
      {
          dataField: 'laki_laki.total',
          text: 'Laki-Laki n',
          sort: true,
          headerAlign: 'center',
          align: 'center'
      },
      {
          dataField: 'laki_laki.persentasi',
          text: 'Laki-Laki %',
          sort: true,
          headerAlign: 'center',
          align: 'center',
          formatter: (key, obj, index) =>{    
            let tampil = obj.laki_laki.persentasi
            return tampil+'%';
          }
      },
      {
          dataField: 'perempuan.total',
          text: 'Perempuan n',
          sort: true,
          headerAlign: 'center',
          align: 'center'
      },
      {
          dataField: 'perempuan.persentasi',
          text: 'Perempuan %',
          sort: true,
          headerAlign: 'center',
          align: 'center',
          formatter: (key, obj, index) =>{    
            let tampil = obj.perempuan.persentasi
            return tampil+'%';
          }
      }
    ]

    // Dashboard Statistik Potensi Desa
    const columns_detail_grafik_potensi = [
      {
      dataField: "no",
          text: "No",
          isDummyField: true,
          csvExport: false,
          headerAlign: 'center',
				  align: 'center',
          formatter: (key, obj, index) =>{          
              let current_pagenum = this.state.paginationDetailGrafikPotensi.current_page;
              let total_records_per_page = this.state.paginationDetailGrafikPotensi.per_page;
              let row_index = (index+1);
              let serial_num = ((total_records_per_page*(current_pagenum-1))+row_index);
              return serial_num; 
          }
      },
      {
        dataField: 'id',
        text: 'NIK',
        sort: true
      },
      {
        dataField: 'nama',
        text: 'Nama',
        sort: true
      },
      {
				dataField: 'dt',
				text: CapitalizeWord(this.state.parentDetailPotensi.replace(/_/g," ").toLowerCase()),
				sort: true,
				formatter: (i, obj) => {
          let fieldParent = ''
          if(this.state.parentDetailPotensi === 'pendidikan_warga'){
            fieldParent = 'data_pendidikan_terakhir'
          }
          else if(this.state.parentDetailPotensi === 'pekerjaan_warga'){
            fieldParent = 'data_pekerjaan'
          }
          else if(this.state.parentDetailPotensi === 'agama_warga'){
            fieldParent = 'data_agama'
          }
          else if(this.state.parentDetailPotensi === 'rentang_usia'){
            fieldParent = 'rentang_usia'
          }
          else if(this.state.parentDetailPotensi === 'golongan_darah_warga'){
            fieldParent = 'data_penduduk_detail'
          }

          let showData = ''
          if(fieldParent){
            showData = obj[fieldParent].nama
          }
          else{
            if(obj[this.state.parentDetailPotensi]){
              showData = obj[this.state.parentDetailPotensi]
            }
            else if(obj['data_'+this.state.parentDetailPotensi]){
              if(Array.isArray(obj['data_'+this.state.parentDetailPotensi])){
                showData = ''

                if(this.state.parentDetailPotensi === 'penguasaan_aset_tanah'){
                  obj['data_'+this.state.parentDetailPotensi].forEach((dt) => {
                    showData = showData + dt.jenis_luas + ', ' ;
                  });
                }
                else{
                  obj['data_'+this.state.parentDetailPotensi].forEach((dt) => {
                    showData = showData + dt['master_'+this.state.parentDetailPotensi].nama + ', ' ;
                  });
                }
              }
              else{
                if(obj['data_'+this.state.parentDetailPotensi]['master_'+this.state.parentDetailPotensi] && obj['data_'+this.state.parentDetailPotensi]['master_'+this.state.parentDetailPotensi].nama){
                  showData = obj['data_'+this.state.parentDetailPotensi]['master_'+this.state.parentDetailPotensi].nama
                }
                else if(obj['data_'+this.state.parentDetailPotensi]['master_'+this.state.parentDetailPotensi] && obj['data_'+this.state.parentDetailPotensi]['master_'+this.state.parentDetailPotensi].nama_status){
                  showData = obj['data_'+this.state.parentDetailPotensi]['master_'+this.state.parentDetailPotensi].nama_status
                }
                else{
                  showData = ''
                }
              }
            }
            else{
              showData = ''
            }
          }

					return showData;
				},
			},
    ]

    // Dashboard Surat Masuk
    var dataSuratMasuk = this.state.dataSuratMasuk;
    const columnsSuratMasuk = [
      {
        dataField: "no",
        text: "No",
        headerAlign: 'center',
        align: 'center',
        formatter: (key, obj, index) => {
          let current_pagenum = this.state.paginationSuratMasuk.current_page;
          let total_records_per_page = this.state.paginationSuratMasuk.per_page;
          let row_index = (index + 1);
          let serial_num = ((total_records_per_page * (current_pagenum - 1)) + row_index);
          return serial_num;
        }
      },
      {
        dataField: "nomor_surat",
        text: "Nomor Surat",
        headerAlign: 'center',
        align: 'center',
        sort: true
      },
      {
        dataField: "dari",
        text: "Asal Surat",
        headerAlign: 'center',
        align: 'center',
        sort: true
      },
      {
        dataField: "tanggal_masuk",
        text: "Tanggal Surat Masuk",
        headerAlign: 'center',
        align: 'center',
        sort: true,
        formatter: (cell, obj) => {
          let plainTime = '-'
					if (obj.tanggal_masuk) {
						let date = new Date(obj.tanggal_masuk)
						date = date.toLocaleString('id-ID')
						
						const datetime = date.split(' ')
	
						date = datetime[0]
	
						const splitDate = date.split('/')
	
						const list_bulan = [
							'Januari',
							'Februari',
							'Maret',
							'April',
							'Mei',
							'Juni',
							'Juli',
							'Agustus',
							'September',
							'Oktober',
							'November',
							'Desember'
						];

						plainTime = `${splitDate[0]} ${list_bulan[parseInt(splitDate[1]) - 1]} ${splitDate[2]}`;
					}

					return plainTime
        }
      },
      {
        dataField: "keterangan",
        text: "Keterangan",
        headerAlign: 'center',
        align: 'center',
        sort: true
      },
      {
        dataField: "aksi",
        text: "Aksi",
        headerAlign: 'center',
        align: 'center',
        formatter: this.tombolAksi
      }
    ]

    let totalLayananMasyarakat = 0;
    let tampilLayananMasyarakat = this.state.layananSuratBaru.map(dt => {
      let symbol = dt.akronim;
      let judul = dt.nama_surat;
      let condition = false;
      if(dt.jenis_layanan === "Masyarakat" && dt.pengaturan_surat && dt.pengaturan_surat.layanan_bo === 1){
        condition = true;
        totalLayananMasyarakat++;
      }
      
      let toData = {
        pathname: dt.route_web, state: dt
      }

      if (!this.state.paid) {
        toData = {
          pathname: "/admin/layanan/join-us"
        }
      }

      if (this.state.paid === null && this.state.lisensi === null) {
        toData = {
          pathname: "/admin/layanan/join-us"
        }
      }

      if (this.state.paid && this.state.lisensi === null) {
        toData = {
          pathname: "/admin/layanan/belum-setting"
        }
      }

      if (this.state.paid && this.state.lisensi === false) {
        toData = {
          pathname: "/admin/layanan/expired"
        }
      }

      if (condition) {
        return (
          <div className="col-sm-6 col-md-12 col-lg-4" style={{ padding: 5 }}>
            <Link
             data-testid={"card|" + dt.nama_surat.toLowerCase()}
             onClick={()=> {
               if (this.props.clickCardSurat) {
                 this.props.clickCardSurat()
               }
             }}
             to={toData}>
              <div className="dashboard-over">
                <b>
                  <span>{symbol}</span>
                  <h6>{judul}</h6>
                </b>
              </div>
            </Link>
          </div>
        );
      } else {
        return "";
      }
    });

    let totalLayananInternal = 0;
    const tampilLayananInternal = this.state.layananSuratBaru.map(dt => {
      let symbol = dt.akronim;
      let judul = dt.nama_surat;
      let condition = false;
      if(dt.jenis_layanan === "Internal" && dt.pengaturan_surat && dt.pengaturan_surat.layanan_bo === 1){
        totalLayananInternal++;
        condition = true;
      }
      
      let toData = {
        pathname: dt.route_web, state: dt
      }

      if (!this.state.paid) {
        toData = {
          pathname: "/admin/layanan/join-us"
        }
      }

      if (this.state.paid === null && this.state.lisensi === null) {
        toData = {
          pathname: "/admin/layanan/join-us"
        }
      }

      if (this.state.paid && this.state.lisensi === null) {
        toData = {
          pathname: "/admin/layanan/belum-setting"
        }
      }

      if (this.state.paid && this.state.lisensi === false) {
        toData = {
          pathname: "/admin/layanan/expired"
        }
      }

      if (condition) {
        return (
          <div className="col-sm-6 col-md-12 col-lg-4" style={{ padding: 5 }}>
            <Link
             data-testid={"card|" + dt.nama_surat.toLowerCase()}
             onClick={()=> {
               if (this.props.clickCardSurat) {
                 this.props.clickCardSurat()
               }
             }}
             to={toData}>
              <div className="dashboard-over">
                <b>
                  <span>{symbol}</span>
                  <h6>{judul}</h6>
                </b>
              </div>
            </Link>
          </div>
        );
      } else {
        return "";
      }
    });

    let totalLayananSuratMasuk = 0;
    const tampilLayananSuratMasuk = this.state.layananSuratBaru.map(dt => {
      let symbol = dt.akronim;
      let judul = dt.nama_surat;
      let condition = false;
      if(dt.jenis_layanan === "Surat Masuk" && dt.pengaturan_surat && dt.pengaturan_surat.layanan_bo === 1){
        totalLayananSuratMasuk++;
        condition = true;
      }
      
      let toData = {
        pathname: dt.route_web, state: dt
      }

      if (!this.state.paid) {
        toData = {
          pathname: "/admin/layanan/join-us"
        }
      }

      if (this.state.paid === null && this.state.lisensi === null) {
        toData = {
          pathname: "/admin/layanan/join-us"
        }
      }

      if (this.state.paid && this.state.lisensi === null) {
        toData = {
          pathname: "/admin/layanan/belum-setting"
        }
      }

      if (this.state.paid && this.state.lisensi === false) {
        toData = {
          pathname: "/admin/layanan/expired"
        }
      }

      if (condition) {
        return (
          <div className="col-sm-6 col-md-12 col-lg-4" style={{ padding: 5 }}>
            <Link
             data-testid={"card|" + dt.nama_surat.toLowerCase()}
             onClick={()=> {
               if (this.props.clickCardSurat) {
                 this.props.clickCardSurat()
               }
             }}
             to={toData}>
              <div className="dashboard-over">
                <b>
                  <span>{symbol}</span>
                  <h6>{judul}</h6>
                </b>
              </div>
            </Link>
          </div>
        );
      } else {
        return "";
      }
    });

    const tampilLayananKecamatan = (
			// <div key="listKecamatan">
      <>
      {
        ID_DESA === '1409012016'
        ?
          <>
          <div className="col-sm-6 col-md-12 col-lg-4" style={{ padding: 5 }}>
            <Link to={{ pathname: '/admin/layanan/kecamatan/pindah-datang'}}>
              <div className="dashboard-over">
                  <b>
                  <span>PD</span>
                  <h6>Penerbitan Pindah/Datang Keluar Daerah</h6>
                  </b>
              </div>
            </Link>
          </div>
          </>
        : ''
      }
				{this.state.layananKecamatan.map((val, i) => {
					let pathname = ''
					let inisial = ''
					switch (val.data_pelayanan.nama.toLowerCase()) {
						case 'surat izin usaha mikro kecil':
							pathname = '/admin/layanan/kecamatan/iumk'
							inisial = 'IUM'
							break;
						case 'surat rekomendasi izin usaha':
							pathname = '/admin/layanan/kecamatan/rekomendasi-usaha'
							inisial = 'RIU'
							break;
            default:
              // no default
              break;
					}

          if (pathname !== '') {
            return (
              <div key={`layanan-kecamatan-${i}`} className="col-sm-6 col-md-12 col-lg-4" style={{ padding: 5 }}>
                <Link to={{ pathname, state: val }}>
                  <div className="dashboard-over">
                    <b>
                      <span>{inisial}</span>
                      <h6>{val.data_pelayanan.nama}</h6>
                    </b>
                  </div>
                </Link>
              </div>
            )
          } else {
            return ''
          }

				})}
      </>
			// </div>
		);

    let bannerAplikasi = require("../assets/images/banner/kampung-tengah.png")
    // if(this.state.data_cek === "Kosong"){
    if(this.state.link_gambar_show !== null){
      bannerAplikasi = localStorage.getItem('BANNER_DASHBOARD')
    }
    
    const styleSelectJenisStatistik = {
      control: styles => ({ ...styles, backgroundColor: '#061569', color: '#FFF' }),
      option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        // const color = chroma(data.color);
        return {
          ...styles,
          backgroundColor: isDisabled
          ? undefined
          : isSelected
          ? '#061569'
          : isFocused
          ? '#6975b8ff'
          : undefined,
          color: isSelected ? '#FFF' : 'black',
          cursor: 'default',
        };
      },
    }

    const styleSelectDetailStatistik = {
      control: styles => ({ ...styles, backgroundColor: 'transparent', borderColor: '#061569', color: '#061569' }),
      option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        // const color = chroma(data.color);
        return {
          ...styles,
          backgroundColor: isDisabled
          ? undefined
          : isSelected
          ? '#061569'
          : isFocused
          ? '#6975b8ff'
          : undefined,
          color: isSelected ? '#FFF' : 'black',
          cursor: 'default',
        };
      },
    }

    var htmlToReactParser = new HtmlToReactParser();

    if (this.state.loading) {
      return (
        <div className="row" data-testid="divLoadingDashboard" style={{ marginTop: '100px' }}>
          <div className="col-sm-12" align="center">
            <img 
            src={require("../assets/images/tes-loading.gif")} 
            alt="loading"
            style={{
              // width: "100%",
              borderRadius: "10px",
              width: '150px'
            }}/> 
          </div>
        </div>
      )
    } else {
      
    return (
      <div>
        <SweetAlert
          show={this.state.show}
          type={this.state.basicType}
          title={this.state.basicTitle}
          confirmBtnBsStyle="success"
          onConfirm={this.closeAlert}
        >
          {this.state.pesanAlert}
        </SweetAlert>
        {this.state.alert}

        {/* Loading preview */}
        <SweetAlert
          show={this.state.loadingPreview}
          showCancel = {false}
          showConfirm={false}
        >
          <div align="center">
            <h5 className="modal-title" style={{ textAlign: "center", color: 'black' }}>Sedang memuat data...</h5>
            <br/>
            <img 
              alt="loading"
              src={require("../assets/images/tes-loading.gif")} 
              style={{
                // width: "100%",
                borderRadius: "10px",
                width: '150px'
              }}
            /> 
            <br/><br/>
          </div>
        </SweetAlert>
        
        <div className="container-fluid" data-testid="dashboard-terpadu">
          {/* <div className="row"> */}
          {
          this.state.akun.sub.data_role !== undefined ? 
            this.state.akun.sub.data_role.nama_role === "Admin" ? (
              <div className="row">
                <div className="col-sm-12">
                  <div className="row">
                    
                    {
                      this.state.tampilGrafik === 'Grafik' && this.state.active_tab_icon === '2'
                      ? 
                      <>
                        <div className="col-sm-12 col-md-12 col-lg-12 pt-2">
                          <div className="card layanan-baru-potensi" style={{ borderRadius: '21px', overflow:"hidden"}}>
                            <div className="card-body" style={{ padding: '15px' }}>
                              {this.state.paid !== null ? (
                                this.state.tampilGrafik === 'Grafik'?
                                <>
                                  <div>
                                    <Nav tabs className="tabs-color">
                                      <NavItem style={{ cursor: 'pointer' }}>
                                        <NavLink
                                          className={classnames({
                                            active: this.state.active_tab_icon === '1'
                                          })}
                                          onClick={() => {
                                            this.setState({ active_tab_icon: '1' })
                                          }}
                                        >
                                          <div className="row">
                                            <div className="col-3" style={{fontSize:'30px'}}>
                                              <i className="icofont icofont-chart-arrows-axis" />
                                            </div>
                                            <div className="col-9">
                                              Statistik <br/>Penduduk
                                            </div>
                                          </div>
                                        </NavLink>
                                      </NavItem>
                                      <NavItem style={{ cursor: 'pointer' }}>
                                        <NavLink
                                          className={classnames({
                                            active: this.state.active_tab_icon === '2'
                                          })}
                                          onClick={() => {
                                            this.setState({ active_tab_icon: '2' })
                                          }}
                                        >
                                          <div className="row">
                                            <div className="col-3" style={{fontSize:'30px'}}>
                                              <i className="icofont icofont-chart-arrows-axis" />
                                            </div>
                                            <div className="col-9">
                                              Statistik <br/>Potensi Desa
                                            </div>
                                          </div>
                                        </NavLink>
                                      </NavItem>
                                    </Nav>
                                    <TabContent activeTab={this.state.active_tab_icon}>
                                      <TabPane tabId="1">
                                      </TabPane>
                                      <TabPane tabId="2">
                                        <div className="row filter-grafik mx-auto">
                                          <div className="col-5 jenis-statistik">
                                            &nbsp;
                                          </div>
                                          <div className="col-3 detail-statistik">
                                            <Select
                                              classNamePrefix="select"
                                              onChange={((e) => { this.getChild(e, 'dusun', 'dus', 'rw') })}
                                              defaultValue={this.state.statistik_penduduk.dusun}
                                              value={this.state.statistik_penduduk.dusun}
                                              name="dusun"
                                              styles={styleSelectDetailStatistik}
                                              options={this.state.frmDsn}
                                              placeholder="Dusun"
                                              isClearable
                                            />
                                          </div>
                                          <div className="col-2 detail-statistik">
                                            <Select
                                              isDisabled={this.state.status.select}
                                              classNamePrefix="select"
                                              onChange={((e) => { this.getChild(e, 'rw', 'rw', 'rt') })}
                                              defaultValue={this.state.statistik_penduduk.rw}
                                              value={this.state.statistik_penduduk.rw}
                                              name="rw"
                                              styles={styleSelectDetailStatistik}
                                              options={this.state.frmRW}
                                              placeholder="RW"
                                              isClearable
                                            />
                                          </div>
                                          <div className="col-2 detail-statistik">
                                            <Select
                                              isDisabled={this.state.status.select}
                                              classNamePrefix="select"
                                              onChange={(e) => this.onChangeSelect(e, 'statistik_penduduk', 'rt')}
                                              defaultValue={this.state.statistik_penduduk.rt}
                                              value={this.state.statistik_penduduk.rt}
                                              name="rt"
                                              styles={styleSelectDetailStatistik}
                                              options={this.state.frmRT}
                                              placeholder="RT"
                                              isClearable
                                            />
                                          </div>
                                        </div>

                                        <div className="row section-grafik mx-auto">
                                          <div className="col-sm-12">
                                            <div className="row section-grafik-penduduk">
                                              <div className="card-total-penduduk" style={{backgroundColor:'#061569'}}>
                                                {this.state.loadingGrafikPotensi ? 
                                                  <>
                                                    <div className="col-sm-12" align="center">
                                                      <div style={{height:'20px'}}>
                                                        &nbsp;
                                                      </div>
                                                      <img
                                                        alt="loading"
                                                        src={require("../assets/images/tes-loading.gif")}
                                                        style={{
                                                          borderRadius: "10px",
                                                          width: '100px'
                                                        }} />
                                                    </div>
                                                  </>
                                                  :
                                                  <>
                                                    <div className="col-5 ilustrasi">
                                                      <img
                                                        id="total-penduduk"
                                                        src={this.state.data_grafik_potensi ? require("../assets/images/user-couple.png").default : require("../assets/images/user-couple.png").default}
                                                        alt="total-penduduk"
                                                      />
                                                    </div>
                                                    <div className="col-7 text">
                                                      <div className="title">
                                                        {/* {data_potensi_penduduk.total} */}
                                                        {this.state.data_grafik_potensi && this.state.data_grafik_potensi.jenis_kelamin && this.state.data_grafik_potensi.jenis_kelamin[0] && this.state.data_grafik_potensi.jenis_kelamin[1] ? this.state.data_grafik_potensi.jenis_kelamin[0].y + this.state.data_grafik_potensi.jenis_kelamin[1].y : 0 }
                                                      </div>
                                                      <div className="description">
                                                        Jumlah Penduduk Seluruhnya
                                                      </div>
                                                    </div>
                                                  </>
                                                }
                                              </div>
                                              <div className="card-total-penduduk" style={{backgroundColor:'#4889D7'}}>
                                                {this.state.loadingGrafikPotensi ? 
                                                  <>
                                                    <div className="col-sm-12" align="center">
                                                      <div style={{height:'20px'}}>
                                                        &nbsp;
                                                      </div>
                                                      <img
                                                        alt="loading"
                                                        src={require("../assets/images/tes-loading.gif")}
                                                        style={{
                                                          borderRadius: "10px",
                                                          width: '100px'
                                                        }} />
                                                    </div>
                                                  </>
                                                  :
                                                  <>
                                                    <div className="col-5 ilustrasi">
                                                      <img
                                                        id="total-pria"
                                                        src={this.state.data_grafik_potensi ? require("../assets/images/user-man.png").default : require("../assets/images/user-man.png").default}
                                                        alt="total-pria"
                                                      />
                                                    </div>
                                                    <div className="col-7 text">
                                                      <div className="title">
                                                        {/* {data_potensi_penduduk.laki_laki} */}
                                                        {this.state.data_grafik_potensi && this.state.data_grafik_potensi.jenis_kelamin && this.state.data_grafik_potensi.jenis_kelamin[0] ? this.state.data_grafik_potensi.jenis_kelamin[0].y : 0 }
                                                      </div>
                                                      <div className="description">
                                                      Jumlah Penduduk Laki-Laki
                                                      </div>
                                                    </div>
                                                  </>
                                                }
                                              </div>
                                              <div className="card-total-penduduk" style={{backgroundColor:'#D7488C'}}>
                                                {this.state.loadingGrafikPotensi ? 
                                                  <>
                                                    <div className="col-sm-12" align="center">
                                                      <div style={{height:'20px'}}>
                                                        &nbsp;
                                                      </div>
                                                      <img
                                                        alt="loading"
                                                        src={require("../assets/images/tes-loading.gif")}
                                                        style={{
                                                          borderRadius: "10px",
                                                          width: '100px'
                                                        }} />
                                                    </div>
                                                  </>
                                                  :
                                                  <>
                                                    <div className="col-5 ilustrasi">
                                                      <img
                                                        id="total-wanita"
                                                        src={this.state.data_grafik_potensi ? require("../assets/images/user-woman.png").default : require("../assets/images/user-woman.png").default}
                                                        alt="total-wanita"
                                                      />
                                                    </div>
                                                    <div className="col-7 text">
                                                      <div className="title">
                                                        {/* {data_potensi_penduduk.perempuan} */}
                                                        {this.state.data_grafik_potensi && this.state.data_grafik_potensi.jenis_kelamin && this.state.data_grafik_potensi.jenis_kelamin[1] ? this.state.data_grafik_potensi.jenis_kelamin[1].y : 0 }
                                                      </div>
                                                      <div className="description">
                                                      Jumlah Penduduk Perempuan
                                                      </div>
                                                    </div>
                                                  </>
                                                }
                                              </div>
                                            </div>
                                            <div className="row section-grafik-potensi">
                                              {/* Grafik Potensi Penduduk */}
                                              <div className="card-potensi">
                                                <div className="col-12 text">
                                                  <div className="title">
                                                    Data Pendidikan
                                                  </div>
                                                  <div className="description">
                                                    {this.state.loadingGrafikPotensi ? 
                                                      <>
                                                        <div className="row">
                                                          <div className="col-sm-12" align="center">
                                                            <div style={{height:'20px'}}>
                                                              &nbsp;
                                                            </div>
                                                            <img
                                                              alt="loading"
                                                              src={require("../assets/images/tes-loading.gif")}
                                                              style={{
                                                                borderRadius: "10px",
                                                                width: '100px'
                                                              }} />
                                                          </div>
                                                        </div>
                                                      </>
                                                      :
                                                        this.state.data_grafik_potensi && this.state.data_grafik_potensi.pendidikan_warga && this.state.data_grafik_potensi.pendidikan_warga.length > 0
                                                      ?
                                                        <>
                                                          <HighchartsReact
                                                            highcharts={Highcharts}
                                                            options={this.getChartOptionsPotensi('pendidikan_warga','pie','single','')}
                                                          />
                                                          <div align="center">
                                                            <button
                                                              className="btn btn-detail-data"
                                                              onClick={() => {
                                                                this.getDataDetailGrafik('pendidikan_warga', 'potensi');
                                                              }}
                                                            >
                                                              <span>Lihat data</span>
                                                            </button>
                                                          </div>
                                                        </>
                                                      :
                                                        <>
                                                          <div className="row">
                                                            <div className="col-sm-12" align="center" style={{marginTop: '10px', marginBottom:'20px'}}>
                                                              Data Belum Ditambahkan
                                                            </div>
                                                          </div>
                                                        </>
                                                    }
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="card-potensi">
                                                <div className="col-12 text">
                                                  <div className="title">
                                                    Data Rentang Usia
                                                  </div>
                                                  <div className="description">
                                                    {this.state.loadingGrafikPotensi ? 
                                                      <>
                                                        <div className="row">
                                                          <div className="col-sm-12" align="center">
                                                            <div style={{height:'20px'}}>
                                                              &nbsp;
                                                            </div>
                                                            <img
                                                              alt="loading"
                                                              src={require("../assets/images/tes-loading.gif")}
                                                              style={{
                                                                borderRadius: "10px",
                                                                width: '100px'
                                                              }} />
                                                          </div>
                                                        </div>
                                                      </>
                                                      :
                                                        this.state.data_grafik_potensi && this.state.data_grafik_potensi.rentang_usia && this.state.data_grafik_potensi.rentang_usia.length > 0
                                                      ?
                                                        <>
                                                          <HighchartsReact
                                                            highcharts={Highcharts}
                                                            options={this.getChartOptionsPotensi('rentang_usia','pie-semi-circle','single','')}
                                                          />
                                                          <div align="center">
                                                            <button
                                                              className="btn btn-detail-data"
                                                              onClick={() => {
                                                                this.getDataDetailGrafik('rentang_usia', 'potensi');
                                                              }}
                                                            >
                                                              <span>Lihat data</span>
                                                            </button>
                                                          </div>
                                                        </>
                                                      :
                                                        <>
                                                          <div className="row">
                                                            <div className="col-sm-12" align="center" style={{marginTop: '10px', marginBottom:'20px'}}>
                                                              Data Belum Ditambahkan
                                                            </div>
                                                          </div>
                                                        </>
                                                    }
                                                  </div>
                                                </div>
                                              </div>

                                              <div className="card-potensi">
                                                <div className="col-12 text">
                                                  <div className="title">
                                                    Data Agama
                                                  </div>
                                                  <div className="description">
                                                    {this.state.loadingGrafikPotensi ? 
                                                      <>
                                                        <div className="row">
                                                          <div className="col-sm-12" align="center">
                                                            <div style={{height:'20px'}}>
                                                              &nbsp;
                                                            </div>
                                                            <img
                                                              alt="loading"
                                                              src={require("../assets/images/tes-loading.gif")}
                                                              style={{
                                                                borderRadius: "10px",
                                                                width: '100px'
                                                              }} />
                                                          </div>
                                                        </div>
                                                      </>
                                                      :
                                                        this.state.data_grafik_potensi && this.state.data_grafik_potensi.agama_warga && this.state.data_grafik_potensi.agama_warga.length > 0
                                                      ?
                                                        <>
                                                          <HighchartsReact
                                                            highcharts={Highcharts}
                                                            options={this.getChartOptionsPotensi('agama_warga','donut','single','')}
                                                          />
                                                          <div align="center">
                                                            <button
                                                              className="btn btn-detail-data"
                                                              onClick={() => {
                                                                this.getDataDetailGrafik('agama_warga', 'potensi');
                                                              }}
                                                            >
                                                              <span>Lihat data</span>
                                                            </button>
                                                          </div>
                                                        </>
                                                      :
                                                        <>
                                                          <div className="row">
                                                            <div className="col-sm-12" align="center" style={{marginTop: '10px', marginBottom:'20px'}}>
                                                              Data Belum Ditambahkan
                                                            </div>
                                                          </div>
                                                        </>
                                                    }
                                                  </div>
                                                </div>
                                              </div>

                                              <div className="card-potensi">
                                                <div className="col-12 text">
                                                  <div className="title">
                                                    Data Pekerjaan
                                                  </div>
                                                  <div className="description">
                                                    {this.state.loadingGrafikPotensi ? 
                                                      <>
                                                        <div className="row">
                                                          <div className="col-sm-12" align="center">
                                                            <div style={{height:'20px'}}>
                                                              &nbsp;
                                                            </div>
                                                            <img
                                                              alt="loading"
                                                              src={require("../assets/images/tes-loading.gif")}
                                                              style={{
                                                                borderRadius: "10px",
                                                                width: '100px'
                                                              }} />
                                                          </div>
                                                        </div>
                                                      </>
                                                      :
                                                        this.state.data_grafik_potensi && this.state.data_grafik_potensi.pekerjaan_warga && this.state.data_grafik_potensi.pekerjaan_warga.length > 0
                                                      ?
                                                        <>
                                                          <HighchartsReact
                                                            highcharts={Highcharts}
                                                            options={this.getChartOptionsPotensi('pekerjaan_warga','pie','single','')}
                                                          />
                                                          <div align="center">
                                                            <button
                                                              className="btn btn-detail-data"
                                                              onClick={() => {
                                                                this.getDataDetailGrafik('pekerjaan_warga', 'potensi');
                                                              }}
                                                            >
                                                              <span>Lihat data</span>
                                                            </button>
                                                          </div>
                                                        </>
                                                      :
                                                        <>
                                                          <div className="row">
                                                            <div className="col-sm-12" align="center" style={{marginTop: '10px', marginBottom:'20px'}}>
                                                              Data Belum Ditambahkan
                                                            </div>
                                                          </div>
                                                        </>
                                                    }
                                                  </div>
                                                </div>
                                              </div>

                                              <div className="card-potensi">
                                                <div className="col-12 text">
                                                  <div className="title">
                                                    Data Status Perkawinan
                                                  </div>
                                                  <div className="description">
                                                    {this.state.loadingGrafikPotensi ? 
                                                      <>
                                                        <div className="row">
                                                          <div className="col-sm-12" align="center">
                                                            <div style={{height:'20px'}}>
                                                              &nbsp;
                                                            </div>
                                                            <img
                                                              alt="loading"
                                                              src={require("../assets/images/tes-loading.gif")}
                                                              style={{
                                                                borderRadius: "10px",
                                                                width: '100px'
                                                              }} />
                                                          </div>
                                                        </div>
                                                      </>
                                                      :
                                                        this.state.data_grafik_potensi && this.state.data_grafik_potensi.status_perkawinan && this.state.data_grafik_potensi.status_perkawinan.length > 0
                                                      ?
                                                        <>
                                                          <HighchartsReact
                                                            highcharts={Highcharts}
                                                            options={this.getChartOptionsPotensi('status_perkawinan','pie-semi-circle','single','Status Perkawinan')}
                                                          />
                                                          <div align="center">
                                                            <button
                                                              className="btn btn-detail-data"
                                                              onClick={() => {
                                                                this.getDataDetailGrafik('status_perkawinan', 'potensi');
                                                              }}
                                                            >
                                                              <span>Lihat data</span>
                                                            </button>
                                                          </div>
                                                        </>
                                                      :
                                                        <>
                                                          <div className="row">
                                                            <div className="col-sm-12" align="center" style={{marginTop: '10px', marginBottom:'20px'}}>
                                                              Data Belum Ditambahkan
                                                            </div>
                                                          </div>
                                                        </>
                                                    }
                                                  </div>
                                                </div>
                                              </div>

                                              <div className="card-potensi">
                                                <div className="col-12 text">
                                                  <div className="title">
                                                    Data Status Penduduk
                                                  </div>
                                                  <div className="description">
                                                    {this.state.loadingGrafikPotensi ? 
                                                      <>
                                                        <div className="row">
                                                          <div className="col-sm-12" align="center">
                                                            <div style={{height:'20px'}}>
                                                              &nbsp;
                                                            </div>
                                                            <img
                                                              alt="loading"
                                                              src={require("../assets/images/tes-loading.gif")}
                                                              style={{
                                                                borderRadius: "10px",
                                                                width: '100px'
                                                              }} />
                                                          </div>
                                                        </div>
                                                      </>
                                                      :
                                                        this.state.data_grafik_potensi && this.state.data_grafik_potensi.status_penduduk && this.state.data_grafik_potensi.status_penduduk.length > 0
                                                      ?
                                                        <>
                                                          <HighchartsReact
                                                            highcharts={Highcharts}
                                                            options={this.getChartOptionsPotensi('status_penduduk','donut','single','Status Penduduk')}
                                                          />
                                                          <div align="center">
                                                            <button
                                                              className="btn btn-detail-data"
                                                              onClick={() => {
                                                                this.getDataDetailGrafik('status_penduduk', 'potensi');
                                                              }}
                                                            >
                                                              <span>Lihat data</span>
                                                            </button>
                                                          </div>
                                                        </>
                                                      :
                                                        <>
                                                          <div className="row">
                                                            <div className="col-sm-12" align="center" style={{marginTop: '10px', marginBottom:'20px'}}>
                                                              Data Belum Ditambahkan
                                                            </div>
                                                          </div>
                                                        </>
                                                    }
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="card-potensi">
                                                <div className="col-12 text">
                                                  <div className="title">
                                                    Data Golongan Darah
                                                  </div>
                                                  <div className="description">
                                                    {this.state.loadingGrafikPotensi ? 
                                                      <>
                                                        <div className="row">
                                                          <div className="col-sm-12" align="center">
                                                            <div style={{height:'20px'}}>
                                                              &nbsp;
                                                            </div>
                                                            <img
                                                              alt="loading"
                                                              src={require("../assets/images/tes-loading.gif")}
                                                              style={{
                                                                borderRadius: "10px",
                                                                width: '100px'
                                                              }} />
                                                          </div>
                                                        </div>
                                                      </>
                                                      :
                                                        this.state.data_grafik_potensi && this.state.data_grafik_potensi.golongan_darah_warga && this.state.data_grafik_potensi.golongan_darah_warga.length > 0
                                                      ?
                                                        <>
                                                          <HighchartsReact
                                                            highcharts={Highcharts}
                                                            options={this.getChartOptionsPotensi('golongan_darah_warga','donut','single','')}
                                                          />
                                                          <div align="center">
                                                            <button
                                                              className="btn btn-detail-data"
                                                              onClick={() => {
                                                                this.getDataDetailGrafik('golongan_darah_warga', 'potensi');
                                                              }}
                                                            >
                                                              <span>Lihat data</span>
                                                            </button>
                                                          </div>
                                                        </>
                                                      :
                                                        <>
                                                          <div className="row">
                                                            <div className="col-sm-12" align="center" style={{marginTop: '10px', marginBottom:'20px'}}>
                                                              Data Belum Ditambahkan
                                                            </div>
                                                          </div>
                                                        </>
                                                    }
                                                  </div>
                                                </div>
                                              </div>
                                              {/* Grafik Potensi Penduduk */}

                                              {/* Grafik Potensi Desa */}
                                              {Object.keys(this.state.data_grafik_potensi_dinamis).map((parent, index)=>(
                                                <div className="card-potensi">
                                                  <div className="col-12 text">
                                                    <div className="title">
                                                      Data {CapitalizeWord(parent.replace(/_/g," ").toLowerCase())}
                                                    </div>
                                                    <div className="description">
                                                      {this.state.loadingGrafikPotensi ? 
                                                        <>
                                                          <div className="row">
                                                            <div className="col-sm-12" align="center">
                                                              <div style={{height:'20px'}}>
                                                                &nbsp;
                                                              </div>
                                                              <img
                                                                alt="loading"
                                                                src={require("../assets/images/tes-loading.gif")}
                                                                style={{
                                                                  borderRadius: "10px",
                                                                  width: '100px'
                                                                }} />
                                                            </div>
                                                          </div>
                                                        </>
                                                        :
                                                          this.state.data_grafik_potensi_dinamis[parent] && this.state.data_grafik_potensi_dinamis[parent].length > 0
                                                        ?
                                                          <>
                                                            <HighchartsReact
                                                              highcharts={Highcharts}
                                                              options={this.getChartOptionsPotensi(parent,'pie','single','')}
                                                            />
                                                            <div align="center">
                                                              <button
                                                                className="btn btn-detail-data"
                                                                onClick={() => {
                                                                  this.getDataDetailGrafik(parent, 'potensi');
                                                                }}
                                                              >
                                                                <span>Lihat data</span>
                                                              </button>
                                                            </div>
                                                          </>
                                                        :
                                                          <>
                                                            <div className="row">
                                                              <div className="col-sm-12" align="center" style={{marginTop: '10px', marginBottom:'20px'}}>
                                                                Data Belum Ditambahkan
                                                              </div>
                                                            </div>
                                                          </>
                                                      }
                                                    </div>
                                                  </div>
                                                </div>
                                              ))}
                                              {/* Grafik Potensi Desa */}
                                            </div>



                                          </div>
                                        </div>
                                        <Modal
                                          open={this.state.status.modalDetailGrafik}
                                          styles={{ modal: { width: '80%' } }}
                                          onClose={this.tutupModal}
                                          // closeOnEsc={true}
                                          // closeOnOverlayClick={true}
                                        >
                                          <div className="modal-header">
                                            <h5 className="modal-title">Data {CapitalizeWord(this.state.parentDetailPotensi.replace(/_/g," ").toLowerCase())}</h5>
                                          </div>
                                          <div className="modal-body">
                                            <ToolkitProvider
                                              data={data_detail_grafik_potensi}
                                              keyField="id"
                                              columns={columns_detail_grafik_potensi}
                                            >
                                              {(props) => (
                                                <div>
                                                  <div className="card-body datatable-react">
                                                    <div className="row" style={{ marginBottom: '12px' }}>
                                                      <div className="col-sm-8">
                                                        <input
                                                          type="text"
                                                          className="form-control"
                                                          id="cariDetail"
                                                          placeholder="Cari berdasarkan nik atau nama"
                                                          onKeyPress={(e) => this.cariDetailGrafikPotensi(e, this.state.parentDetailPotensi)}
                                                          style={{ marginBottom: '0px' }}
                                                        />
                                                      </div>
                                                      <div className="col-sm-4">
                                                        <Select
                                                          classNamePrefix="select"
                                                          onChange={(e) => {
                                                            this.state.filterGrafikPotensiDetail = e;
                                                            this.getDataDetailGrafik(this.state.parentDetailPotensi, 'potensi');
                                                            this.state.urlCari = ""
                                                            this.forceUpdate();
                                                          }}
                                                          defaultValue={this.state.filterGrafikPotensiDetail}
                                                          value={this.state.filterGrafikPotensiDetail}
                                                          name="filter-grafik-potensi-detail"
                                                          options={this.state.frmSelectGrafikPotensiDetail && this.state.frmSelectGrafikPotensiDetail[this.state.parentDetailPotensi] ? this.state.frmSelectGrafikPotensiDetail[this.state.parentDetailPotensi] : []}
                                                          placeholder= {CapitalizeWord(this.state.parentDetailPotensi.replace(/_/g," ").toLowerCase())}
                                                          isClearable
                                                          required
                                                        />
                                                      </div>
                                                    </div>

                                                    {
                                                      this.state.loadingGrafikPotensiDetail?
                                                      <>
                                                        <div className="row">
                                                          <div className="col-sm-12" align="center">
                                                            <div style={{height:'20px'}}>
                                                              &nbsp;
                                                            </div>
                                                            <img
                                                              alt="loading"
                                                              src={require("../assets/images/tes-loading.gif")}
                                                              style={{
                                                                borderRadius: "10px",
                                                                width: '100px'
                                                              }} />
                                                          </div>
                                                        </div>
                                                      </>
                                                      :
                                                      <>
                                                        <BootstrapTable
                                                          {...props.baseProps}
                                                          keyField="id"
                                                          data={data_detail_grafik_potensi}
                                                          columns={columns_detail_grafik_potensi}
                                                        />

                                                        <div className="pull-right text-white">
                                                          {this.state.awalDetailGrafikPotensi}
                                                          {this.state.sebelumDetailGrafikPotensi}
                                                          {this.state.halDetailGrafikPotensi.map((dt) => {
                                                            return dt;
                                                          })}
                                                          {this.state.setelahDetailGrafikPotensi}
                                                          {this.state.akhirDetailGrafikPotensi}
                                                        </div>
                                                      </>
                                                    }
                                                  </div>
                                                </div>
                                              )}
                                            </ToolkitProvider>
                                          </div>
                                        </Modal>
                                      </TabPane>
                                    </TabContent>
                                  </div>
                                </>
                                :
                                <div>
                                  <Nav tabs className="tabs-color">
                                    <NavItem style={{ cursor: 'pointer' }}>
                                      <NavLink
                                        className={classnames({
                                          active: this.state.active_tab_icon === '1'
                                        })}
                                        onClick={() => {
                                          this.setState({ 
                                            layananSuratBaru: this.state.layananSuratBaruPermanent,
                                            cariSurat: '',
                                            active_tab_icon: '1' 
                                          })
                                        }}
                                      >
                                        <i className="icofont icofont-ui-home" />
                                        {/* {JENIS_DESA} */}
                                        {localStorage.getItem('JENIS_DESA')}
                                        {/* {this.state.paid ? JENIS_DESA : "Kecamatan"} */}
                                      </NavLink>
                                    </NavItem>
                                    <NavItem style={{ cursor: 'pointer' }}>
                                      <NavLink
                                        className={classnames({
                                          active: this.state.active_tab_icon === '2'
                                        })}
                                        onClick={() => {
                                          this.setState({ 
                                            layananSuratBaru: this.state.layananSuratBaruPermanent,
                                            cariSurat: '',
                                            active_tab_icon: '2' 
                                          })
                                        }}
                                      >
                                        <i className="icofont icofont-ui-home" />
                                        Internal
                                        {/* {this.state.paid ? "Kecamatan" : JENIS_DESA} */}
                                      </NavLink>
                                    </NavItem>
                                    <NavItem style={{ cursor: 'pointer' }}>
                                      <NavLink
                                        className={classnames({
                                          active: this.state.active_tab_icon === '2'
                                        })}
                                        onClick={() => {
                                          this.setState({ 
                                            layananSuratBaru: this.state.layananSuratBaruPermanent,
                                            cariSurat: '',
                                            active_tab_icon: '2' 
                                          })
                                        }}
                                      >
                                        <i className="icofont icofont-ui-home" />
                                        Surat Masuk
                                        {/* {this.state.paid ? "Kecamatan" : JENIS_DESA} */}
                                      </NavLink>
                                    </NavItem>
                                  </Nav>
                                  <TabContent activeTab={this.state.active_tab_icon}>
                                    <TabPane tabId="1">
                                      {this.state.loadingListLayanan ? (
                                        <div className="row">
                                          <div className="col-sm-12" align="center">
                                            <div style={{height:'200px'}}>
                                              &nbsp;
                                            </div>
                                            <img
                                              alt="loading"
                                              src={require("../assets/images/tes-loading.gif")}
                                              style={{
                                                borderRadius: "10px",
                                                width: '100px'
                                              }} />
                                          </div>
                                        </div>
                                        ) : (
                                          
                                          totalLayananMasyarakat === 0
                                          ?
                                            <div className="row">
                                              <div className="col-sm-12" align="center">
                                                <div style={{height:'100px'}}>
                                                  &nbsp;
                                                </div>
                                                Layanan Tidak Ada !
                                              </div>
                                            </div>
                                          :
                                            <div key={ Math.random().toString(36).substr(2, 9) } className="row pt-3 m-0">
                                              {tampilLayananMasyarakat}
                                            </div>
                                        )
                                      }
                                    </TabPane>
                                    <TabPane tabId="2">
                                      {
                                        totalLayananInternal === 0
                                        ?
                                          <div className="row">
                                            <div className="col-sm-12" align="center">
                                              <div style={{height:'100px'}}>
                                                &nbsp;
                                              </div>
                                              Layanan Tidak Ada !
                                            </div>
                                          </div>
                                        :
                                          <div key={ Math.random().toString(36).substr(2, 9) } className="row pt-3 m-0">
                                            {tampilLayananInternal}
                                          </div>
                                      }
                                    </TabPane>
                                    <TabPane tabId="3">
                                      {
                                        totalLayananSuratMasuk === 0
                                        ?
                                          <div className="row">
                                            <div className="col-sm-12" align="center">
                                              <div style={{height:'100px'}}>
                                                &nbsp;
                                              </div>
                                              Layanan Tidak Ada !
                                            </div>
                                          </div>
                                        :
                                          <div key={ Math.random().toString(36).substr(2, 9) } className="row pt-3 m-0">
                                            {tampilLayananSuratMasuk}
                                          </div>
                                      }
                                    </TabPane>
                                  </TabContent>
                                </div>
                              ) : ''}
                            </div>
                          </div>
                        </div>
                      </>
                      :
                      <>
                        <div className="col-sm-12 col-md-6 col-lg-8 pt-2 mx-auto">
                          <div className="card layanan-baru " style={{ borderRadius: '21px', overflow:"hidden"}}>
                            <div className="card-body" style={{ padding: '15px' }}>
                              {/* {this.state.paid ? (
                                <div key={ Math.random().toString(36).substr(2, 9) } className="row m-0">
                                  {tampilLayanan}
                                </div>
                              ) : ''} */}
                              {this.state.paid !== null ? (
                                this.state.tampilGrafik === 'Grafik'?
                                <>
                                  <div>
                                    <Nav tabs className="tabs-color">
                                      <NavItem style={{ cursor: 'pointer' }}>
                                        <NavLink
                                          className={classnames({
                                            active: this.state.active_tab_icon === '1'
                                          })}
                                          onClick={() => {
                                            this.setState({ 
                                              active_tab_icon: '1',
                                            })
                                          }}
                                        >
                                          <div className="row">
                                            <div className="col-3" style={{fontSize:'30px'}}>
                                              <i className="icofont icofont-chart-arrows-axis" />
                                            </div>
                                            <div className="col-9">
                                              Statistik <br/>Penduduk
                                            </div>
                                          </div>
                                        </NavLink>
                                      </NavItem>
                                      <NavItem style={{ cursor: 'pointer' }}>
                                        <NavLink
                                          className={classnames({
                                            active: this.state.active_tab_icon === '2'
                                          })}
                                          onClick={() => {
                                            this.setState({ 
                                              active_tab_icon: '2',
                                            })
                                          }}
                                        >
                                          <div className="row">
                                            <div className="col-3" style={{fontSize:'30px'}}>
                                              <i className="icofont icofont-chart-arrows-axis" />
                                            </div>
                                            <div className="col-9">
                                              Statistik <br/>Potensi Desa
                                            </div>
                                          </div>
                                        </NavLink>
                                      </NavItem>
                                    </Nav>
                                    <TabContent activeTab={this.state.active_tab_icon}>
                                      <TabPane tabId="1">
                                        <div className="row filter-grafik mx-auto" style={{paddingLeft: "0px", paddingRight:"0px"}}>
                                          <div className="col-5 jenis-statistik">
                                            <Select
                                              classNamePrefix="select"
                                              onChange={(e) => this.onChangeSelect(e, 'statistik_penduduk', 'jenis')}
                                              value={this.state.statistik_penduduk.jenis}
                                              name="jenis"
                                              styles={styleSelectJenisStatistik}
                                              options={this.state.frmFilterStatistikPenduduk}
                                              placeholder="Pilih Statistik Penduduk"
                                              // isClearable
                                            />
                                          </div>
                                          <div className="col-3 detail-statistik">
                                            <Select
                                              classNamePrefix="select"
                                              onChange={((e) => { this.getChild(e, 'dusun', 'dus', 'rw') })}
                                              defaultValue={this.state.statistik_penduduk.dusun}
                                              value={this.state.statistik_penduduk.dusun}
                                              name="dusun"
                                              styles={styleSelectDetailStatistik}
                                              options={this.state.frmDsn}
                                              placeholder="Dusun"
                                              isClearable
                                            />
                                          </div>
                                          <div className="col-2 detail-statistik">
                                            <Select
                                              isDisabled={this.state.status.select}
                                              classNamePrefix="select"
                                              onChange={((e) => { this.getChild(e, 'rw', 'rw', 'rt') })}
                                              defaultValue={this.state.statistik_penduduk.rw}
                                              value={this.state.statistik_penduduk.rw}
                                              name="rw"
                                              styles={styleSelectDetailStatistik}
                                              options={this.state.frmRW}
                                              placeholder="RW"
                                              isClearable
                                            />
                                          </div>
                                          <div className="col-2 detail-statistik">
                                            <Select
                                              isDisabled={this.state.status.select}
                                              classNamePrefix="select"
                                              onChange={(e) => this.onChangeSelect(e, 'statistik_penduduk', 'rt')}
                                              defaultValue={this.state.statistik_penduduk.rt}
                                              value={this.state.statistik_penduduk.rt}
                                              name="rt"
                                              styles={styleSelectDetailStatistik}
                                              options={this.state.frmRT}
                                              placeholder="RT"
                                              isClearable
                                            />
                                          </div>
                                        </div>

                                        <div className="row mx-auto">
                                          <div className="section-grafik col-sm-12 mx-auto">
                                            <div className="row mx-auto">
                                              <div className="title col-6">
                                              {this.state.statistik_penduduk.mode === 'grafik'?'Grafik':'Tabel'} { CapitalizeWord(this.state.statistik_penduduk.jenis.value.replace(/_/g," ").toLowerCase())}
                                              </div>
                                              <div className="change-view col-6">
                                                <span
                                                  style={{ cursor: "pointer", color: "#000000" }}
                                                  onClick={() => {
                                                    this.changeView('statistik_penduduk', this.state.statistik_penduduk.mode);
                                                  }}
                                                >
                                                  {
                                                    this.state.statistik_penduduk.mode === 'grafik'
                                                    ?
                                                      'Lihat Tampilan Tabel'
                                                    :  
                                                      'Lihat Tampilan Grafik'
                                                  }
                                                </span>
                                              </div>
                                            </div>
                                            {
                                              this.state.statistik_penduduk.mode === 'grafik'
                                              ? <></>
                                              :
                                                <div className="row mx-auto">
                                                  <div className="title col-6">
                                                    &nbsp;
                                                  </div>
                                                  <div className="change-view col-6">
                                                    <button
                                                      className="btn btn-primary"
                                                      onClick={() => {
                                                        this.setState({
                                                          status:{
                                                            ...this.state.status,
                                                            alertExport: true,
                                                          }
                                                        })
                                                      }}
                                                    >
                                                      <span>Export Data</span>
                                                    </button>
                                                  </div>
                                                </div>
                                            }

                                            <div className="row mx-auto">
                                            {
                                                this.state.statistik_penduduk.mode === 'grafik'
                                                ? 
                                                  <div className="grafik col-12">
                                                    {this.state.loadingGrafik ? 
                                                    <>
                                                      <div className="row">
                                                        <div className="col-sm-12" align="center">
                                                          <div style={{height:'20px'}}>
                                                            &nbsp;
                                                          </div>
                                                          <img
                                                            alt="loading"
                                                            src={require("../assets/images/tes-loading.gif")}
                                                            style={{
                                                              borderRadius: "10px",
                                                              width: '100px'
                                                            }} />
                                                        </div>
                                                      </div>
                                                    </>
                                                    :
                                                    <>
                                                    <HighchartsReact
                                                      highcharts={Highcharts}
                                                      options={this.getChartOptions(this.state.statistik_penduduk.jenis.value)}
                                                    />
                                                    </>
                                                    }
                                                  </div>
                                                :  
                                                  <div className="table col-12 mt-auto mb-5">
                                                    {this.state.loadingGrafik ? 
                                                    <>
                                                      <div className="row">
                                                        <div className="col-sm-12" align="center">
                                                          <div style={{height:'20px'}}>
                                                            &nbsp;
                                                          </div>
                                                          <img
                                                            alt="loading"
                                                            src={require("../assets/images/tes-loading.gif")}
                                                            style={{
                                                              borderRadius: "10px",
                                                              width: '100px'
                                                            }} />
                                                        </div>
                                                      </div>
                                                    </>
                                                    : 
                                                    <>
                                                      <BootstrapTable keyField="id" data={data_detail} columns={columns} />
                                                      {
                                                        data_detail.length > 0
                                                        ? ''
                                                        :
                                                          <center style={{marginTop:'20px'}}>Data Tidak Ada!</center>
                                                      }
                                                    </>
                                                    }
                                                  </div>
                                              }
                                            </div>
                                          </div>
                                        </div>

                                        <SweetAlert
                                          show={this.state.status.alertExport}
                                          type="info"
                                          title="Export Data"
                                          cancelBtnBsStyle="danger"
                                          showCancel={false}
                                          onCancel={() => {
                                            this.setState({
                                              jenisDokumen: '',
                                              status:{
                                                ...this.state.status,
                                                alertExport: false,
                                                modalExport: false,
                                              },
                                            })
                                          }}
                                          closeOnOverlayClick={true}
                                          showConfirm={false}
                                          onConfirm={() => { }}
                                        >
                                          <span style={{ fontSize: '17px' }}>Pilih Format Dokumen</span>
                                          <br />
                                          <Button
                                            color="success"
                                            onClick={() => {
                                              this.setState({
                                                jenisDokumen: 'pdf',
                                                status:{
                                                  ...this.state.status,
                                                  alertExport: false,
                                                  modalExport: true,
                                                },
                                              })
                                            }}
                                          >
                                            <span style={{ color: 'white' }}>Format PDF</span>
                                          </Button>
                                          {'   '}
                                          <Button
                                            color="info"
                                            onClick={() => {
                                              this.setState({
                                                jenisDokumen: 'excel',
                                                status:{
                                                  ...this.state.status,
                                                  alertExport: false,
                                                  modalExport: true,
                                                }
                                              })
                                            }}
                                            target="blank"
                                          >
                                            <span style={{ color: 'white' }}>Format Excel</span>
                                          </Button>
                                        </SweetAlert>

                                        <Modal
                                          open={this.state.status.modalExport}
                                          onClose={() => {
                                            this.setState({
                                              status:{
                                                ...this.state.status,
                                                modalExport: false,
                                              },
                                              jenisDokumen: '',
                                            })
                                          }}
                                          classNames={{ overlay: 'custom-map-modal' }}
                                          styles={{ modal: { width: '440px', height:'240px' } }}
                                          closeOnEsc={false}
                                          closeOnOverlayClick={false}
                                        >
                                            <div
                                              className="modal-body"
                                              style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                flexDirection: 'column',
                                                alignItems: 'center'
                                              }}
                                            >
                                              <Form onSubmit={this.prosesExport}>
                                                <div className="modal-header">
                                                  <h5 className="modal-title">Masukkan email anda</h5>
                                                </div>

                                                <div className="modal-body">
                                                  <FormGroup className="row">
                                                    <Col sm="12">
                                                      <input
                                                        className="form-control"
                                                        id="email"
                                                        placeholder="Isi email disini"
                                                        type="email"
                                                        required
                                                        autoFocus
                                                      />
                                                    </Col>
                                                  </FormGroup>

                                                  <div className="modal-footer" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                                    <button
                                                      type="button"
                                                      className="btn btn-danger"
                                                      onClick={() => {
                                                        this.setState({
                                                          status:{
                                                            ...this.state.status,
                                                            modalExport: false,
                                                          },
                                                          jenisDokumen: '',
                                                        })
                                                      }}
                                                    >
                                                      Tutup
                                                    </button>
                                                    <button type="submit" className="btn btn-success">
                                                      Lanjutkan
                                                    </button>
                                                  </div>
                                                </div>
                                              </Form>
                                            </div>
                                        </Modal>

                                        <Modal
                                          open={this.state.status.modalDetailGrafik}
                                          styles={{ modal: { width: '80%' } }}
                                          onClose={this.tutupModal}
                                          // closeOnEsc={true}
                                          // closeOnOverlayClick={true}
                                        >
                                          <div className="modal-header">
                                            <h5 className="modal-title">Data {CapitalizeWord(this.state.parentDetailPotensi.replace(/_/g," ").toLowerCase())}</h5>
                                          </div>
                                          <div className="modal-body">
                                            <ToolkitProvider
                                              data={data_detail_grafik_potensi}
                                              keyField="id"
                                              columns={columns_detail_grafik_potensi}
                                            >
                                              {(props) => (
                                                <div>
                                                  <div className="card-body datatable-react">
                                                    <div className="row" style={{ marginBottom: '12px' }}>
                                                      <div className="col-sm-8">
                                                        <input
                                                          type="text"
                                                          className="form-control"
                                                          id="cariDetail"
                                                          placeholder="Cari berdasarkan nik atau nama"
                                                          onKeyPress={(e) => this.cariDetailGrafikPotensi(e, this.state.parentDetailPotensi)}
                                                          style={{ marginBottom: '0px' }}
                                                        />
                                                      </div>
                                                      <div className="col-sm-4">
                                                        <Select
                                                          classNamePrefix="select"
                                                          onChange={(e) => {
                                                            this.state.filterGrafikPotensiDetail = e;
                                                            this.getDataDetailGrafik(this.state.parentDetailPotensi, 'potensi');
                                                            this.state.urlCari = ""
                                                            this.forceUpdate();
                                                          }}
                                                          defaultValue={this.state.filterGrafikPotensiDetail}
                                                          value={this.state.filterGrafikPotensiDetail}
                                                          name="filter-grafik-potensi-detail"
                                                          options={this.state.frmSelectGrafikPotensiDetail && this.state.frmSelectGrafikPotensiDetail[this.state.parentDetailPotensi] ? this.state.frmSelectGrafikPotensiDetail[this.state.parentDetailPotensi] : []}
                                                          placeholder= {CapitalizeWord(this.state.parentDetailPotensi.replace(/_/g," ").toLowerCase())}
                                                          isClearable
                                                          required
                                                        />
                                                      </div>
                                                    </div>

                                                    {
                                                      this.state.loadingGrafikPotensiDetail?
                                                      <>
                                                        <div className="row">
                                                          <div className="col-sm-12" align="center">
                                                            <div style={{height:'20px'}}>
                                                              &nbsp;
                                                            </div>
                                                            <img
                                                              alt="loading"
                                                              src={require("../assets/images/tes-loading.gif")}
                                                              style={{
                                                                borderRadius: "10px",
                                                                width: '100px'
                                                              }} />
                                                          </div>
                                                        </div>
                                                      </>
                                                      :
                                                      <>
                                                        <BootstrapTable
                                                          {...props.baseProps}
                                                          keyField="id"
                                                          data={data_detail_grafik_potensi}
                                                          columns={columns_detail_grafik_potensi}
                                                        />

                                                        <div className="pull-right text-white">
                                                          {this.state.awalDetailGrafikPotensi}
                                                          {this.state.sebelumDetailGrafikPotensi}
                                                          {this.state.halDetailGrafikPotensi.map((dt) => {
                                                            return dt;
                                                          })}
                                                          {this.state.setelahDetailGrafikPotensi}
                                                          {this.state.akhirDetailGrafikPotensi}
                                                        </div>
                                                      </>
                                                    }
                                                  </div>
                                                </div>
                                              )}
                                            </ToolkitProvider>
                                          </div>
                                        </Modal>
                                        
                                      </TabPane>
                                      <TabPane tabId="2">
                                        {/* <div className="row filter-grafik mx-auto">
                                          <div className="col-5 jenis-statistik">
                                            &nbsp;
                                          </div>
                                          <div className="col-3 detail-statistik">
                                            <Select
                                              classNamePrefix="select"
                                              onChange={((e) => { this.getChild(e, 'dusun', 'dus', 'rw') })}
                                              defaultValue={this.state.statistik_penduduk.dusun}
                                              value={this.state.statistik_penduduk.dusun}
                                              name="dusun"
                                              styles={styleSelectDetailStatistik}
                                              options={this.state.frmDsn}
                                              placeholder="Dusun"
                                              isClearable
                                            />
                                          </div>
                                          <div className="col-2 detail-statistik">
                                            <Select
                                              isDisabled={this.state.status.select}
                                              classNamePrefix="select"
                                              onChange={((e) => { this.getChild(e, 'rw', 'rw', 'rt') })}
                                              defaultValue={this.state.statistik_penduduk.rw}
                                              value={this.state.statistik_penduduk.rw}
                                              name="rw"
                                              styles={styleSelectDetailStatistik}
                                              options={this.state.frmRW}
                                              placeholder="RW"
                                              isClearable
                                            />
                                          </div>
                                          <div className="col-2 detail-statistik">
                                            <Select
                                              isDisabled={this.state.status.select}
                                              classNamePrefix="select"
                                              onChange={(e) => this.onChangeSelect(e, 'statistik_penduduk', 'rt')}
                                              defaultValue={this.state.statistik_penduduk.rt}
                                              value={this.state.statistik_penduduk.rt}
                                              name="rt"
                                              styles={styleSelectDetailStatistik}
                                              options={this.state.frmRT}
                                              placeholder="RT"
                                              isClearable
                                            />
                                          </div>
                                        </div> */}

                                        {/* <div className="row section-grafik mx-auto">
                                          <div className="col-sm-12">
                                            <div className="row section-grafik-penduduk">
                                              <div className="card-total-penduduk" style={{backgroundColor:'#061569'}}>
                                                <div className="col-5 ilustrasi">
                                                  <img
                                                    id="total-penduduk"
                                                    src={require("../assets/images/user-couple.png").default}
                                                    alt="total-penduduk"
                                                  />
                                                </div>
                                                <div className="col-7 text">
                                                  <div className="title">
                                                    {data_potensi_penduduk.total}
                                                  </div>
                                                  <div className="description">
                                                    Jumlah Penduduk Seluruhnya
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="card-total-penduduk" style={{backgroundColor:'#4889D7'}}>
                                                <div className="col-5 ilustrasi">
                                                  <img
                                                    id="total-pria"
                                                    src={require("../assets/images/user-man.png").default}
                                                    alt="total-pria"
                                                  />
                                                </div>
                                                <div className="col-7 text">
                                                  <div className="title">
                                                    {data_potensi_penduduk.laki_laki}
                                                  </div>
                                                  <div className="description">
                                                  Jumlah Penduduk Laki-Laki
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="card-total-penduduk" style={{backgroundColor:'#D7488C'}}>
                                                <div className="col-5 ilustrasi">
                                                  <img
                                                    id="total-wanita"
                                                    src={require("../assets/images/user-woman.png").default}
                                                    alt="total-wanita"
                                                  />
                                                </div>
                                                <div className="col-7 text">
                                                  <div className="title">
                                                    {data_potensi_penduduk.perempuan}
                                                  </div>
                                                  <div className="description">
                                                  Jumlah Penduduk Perempuan
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="row section-grafik-potensi">
                                              <div className="card-potensi">
                                                <div className="col-12 text">
                                                  <div className="title">
                                                    Data Pendidikan
                                                  </div>
                                                  <div className="description">
                                                    blabla
                                                    {this.state.loadingGrafikPotensi ? 
                                                      <>
                                                        <div className="row">
                                                          <div className="col-sm-12" align="center">
                                                            <div style={{height:'20px'}}>
                                                              &nbsp;
                                                            </div>
                                                            <img
                                                              alt="loading"
                                                              src={require("../assets/images/tes-loading.gif")}
                                                              style={{
                                                                borderRadius: "10px",
                                                                width: '100px'
                                                              }} />
                                                          </div>
                                                        </div>
                                                      </>
                                                      :
                                                      <>
                                                        <HighchartsReact
                                                          highcharts={Highcharts}
                                                          options={this.getChartOptionsPotensi('pendidikan_warga','pie')}
                                                        />
                                                      </>
                                                    }
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div> */}
                                      </TabPane>
                                    </TabContent>
                                  </div>
                                </>
                                :
                                <div>
                                  <Nav tabs className="tabs-color">
                                    <NavItem style={{ cursor: 'pointer' }}>
                                      <NavLink
                                        className={classnames({
                                          active: this.state.active_tab_icon === '1'
                                        })}
                                        onClick={() => {
                                          this.setState({ 
                                            active_tab_icon: '1',
                                            layananSuratBaru: this.state.layananSuratBaruPermanent,
                                            cariSurat: '',
                                          })
                                        }}
                                      >
                                        <i className="icofont icofont-ui-home" />
                                        {/* {JENIS_DESA} */}
                                        {localStorage.getItem('JENIS_DESA')}
                                        {/* {this.state.paid ? JENIS_DESA : "Kecamatan"} */}
                                      </NavLink>
                                    </NavItem>
                                    <NavItem style={{ cursor: 'pointer' }}>
                                      <NavLink
                                        className={classnames({
                                          active: this.state.active_tab_icon === '2'
                                        })}
                                        onClick={() => {
                                          this.setState({ 
                                            layananSuratBaru: this.state.layananSuratBaruPermanent,
                                            cariSurat: '',
                                            active_tab_icon: '2',
                                          })
                                        }}
                                      >
                                        <i className="icofont icofont-ui-home" />
                                        Internal
                                        {/* {this.state.paid ? "Kecamatan" : JENIS_DESA} */}
                                      </NavLink>
                                    </NavItem>
                                    <NavItem style={{ cursor: 'pointer' }}>
                                      <NavLink
                                        className={classnames({
                                          active: this.state.active_tab_icon === '3'
                                        })}
                                        onClick={() => {
                                          this.setState({ 
                                            layananSuratBaru: this.state.layananSuratBaruPermanent,
                                            cariSurat: '',
                                            active_tab_icon: '3',
                                          })
                                        }}
                                      >
                                        <i className="icofont icofont-ui-home" />
                                        Surat Masuk
                                        {/* {this.state.paid ? "Kecamatan" : JENIS_DESA} */}
                                      </NavLink>
                                    </NavItem>
                                  </Nav>
                                  <TabContent activeTab={this.state.active_tab_icon}>
                                    <TabPane tabId="1">
                                      {this.state.loadingListLayanan ? (
                                        <div className="row">
                                          <div className="col-sm-12" align="center">
                                            <div style={{height:'200px'}}>
                                              &nbsp;
                                            </div>
                                            <img
                                              alt="loading"
                                              src={require("../assets/images/tes-loading.gif")}
                                              style={{
                                                borderRadius: "10px",
                                                width: '100px'
                                              }} />
                                          </div>
                                        </div>
                                        ) : (
                                          
                                          totalLayananMasyarakat === 0
                                          ?
                                          <>
                                            <div className="mt-4 mr-1 ml-1">
                                              <input
                                                type="text"
                                                className="form-control"
                                                id="cariTable"
                                                placeholder="Cari Berdasarkan Nama Surat"
                                                defaultValue={this.state.cariSurat}
                                                onKeyPress={this.cariLayanan}
                                              />
                                            </div>
                                            <div className="row">
                                              <div className="col-sm-12" align="center">
                                                <div style={{height:'100px'}}>
                                                  &nbsp;
                                                </div>
                                                Layanan Tidak Ada !
                                              </div>
                                            </div>
                                          </>
                                          :
                                          <>
                                            <div className="mt-4 mr-1 ml-1">
                                              <input
                                                type="text"
                                                className="form-control"
                                                id="cariTable"
                                                placeholder="Cari Berdasarkan Nama Surat"
                                                defaultValue={this.state.cariSurat}
                                                onKeyPress={this.cariLayanan}
                                              />
                                            </div>
                                            <div key={ Math.random().toString(36).substr(2, 9) } className="row pt-3 m-0">
                                              {tampilLayananMasyarakat}
                                            </div>
                                          </>
                                        )
                                      }
                                    </TabPane>
                                    <TabPane tabId="2">
                                      {
                                        this.state.loadingListLayanan ? (
                                          <div className="row">
                                            <div className="col-sm-12" align="center">
                                              <div style={{height:'200px'}}>
                                                &nbsp;
                                              </div>
                                              <img
                                                alt="loading"
                                                src={require("../assets/images/tes-loading.gif")}
                                                style={{
                                                  borderRadius: "10px",
                                                  width: '100px'
                                                }} />
                                            </div>
                                          </div>
                                        ) : (
                                          totalLayananInternal === 0
                                          ?
                                            <>
                                              <div className="mt-4 mr-1 ml-1">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  id="cariTable"
                                                  placeholder="Cari Berdasarkan Nama Surat"
                                                  defaultValue={this.state.cariSurat}
                                                  onKeyPress={this.cariLayanan}
                                                />
                                              </div>
                                              <div className="row">
                                                <div className="col-sm-12" align="center">
                                                  <div style={{height:'100px'}}>
                                                    &nbsp;
                                                  </div>
                                                  Layanan Tidak Ada !
                                                </div>
                                              </div>
                                            </>
                                          :
                                          <>
                                            <div className="mt-4 mr-1 ml-1">
                                              <input
                                                type="text"
                                                className="form-control"
                                                id="cariTable"
                                                placeholder="Cari Berdasarkan Nama Surat"
                                                defaultValue={this.state.cariSurat}
                                                onKeyPress={this.cariLayanan}
                                              />
                                            </div>
                                            <div key={ Math.random().toString(36).substr(2, 9) } className="row pt-3 m-0">
                                              {tampilLayananInternal}
                                            </div>
                                          </>
                                        )
                                      }
                                    </TabPane>
                                    <TabPane tabId="3">
                                      <div style={{ marginTop: "15px" }}>
                                        <div className="card-body" style={{ backgroundColor: "white",marginTop: "15px" }}>
                                          <div className="row mx-auto">
                                            {this.state.loading ? (
                                              <div className="col-sm-12" align="center">
                                                <img 
                                                alt="loading"
                                                src={require("../assets/images/tes-loading.gif")} 
                                                style={{
                                                // width: "100%",
                                                borderRadius: "10px",
                                                width: '100px'
                                                }}/> 
                                              </div>
                                              ) : (
                                                <>
                                                  <div className="col-lg-6">
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      id="cariTable"
                                                      placeholder="Cari Data Surat Masuk"
                                                      onKeyPress={this.cariDataSuratMasuk}
                                                    />
                                                  </div>
                                                  <div className="col-lg-6 text-right">
                                                    <Button
                                                      size="sm"
                                                      color="success"
                                                      className="btn-square ml-2"
                                                      onClick={() => {
                                                        this.setState({
                                                          loadingPreview: false,
                                                          dt: frmInput,
                                                          link_gambar: '',
                                                        })
                                                        this.bukaFormSuratMasuk();
                                                      }}
                                                    >
                                                      Tambah Data
                                                    </Button>
                                                  </div>
                                                  {this.state.loadingSuratMasuk ? (
                                                    <div className="col-sm-12 mt-5" align="center">
                                                      <img 
                                                      alt="loading"
                                                      src={require("../assets/images/tes-loading.gif")} 
                                                      style={{
                                                      // width: "100%",
                                                      borderRadius: "10px",
                                                      width: '100px'
                                                      }}/> 
                                                    </div>
                                                  ) : (
                                                    <>
                                                      {dataSuratMasuk.length > 0 ? (
                                                        <>
                                                          <div className='col-12' style={{ paddingTop:'20px' }}>
                                                            <BootstrapTable keyField="id" data={dataSuratMasuk} columns={columnsSuratMasuk} />
                                                            <div className="pull-right text-white" style={{ paddingTop:'20px' }}>
                                                              {this.state.awalSuratMasuk}
                                                              {this.state.sebelumSuratMasuk}
                                                              {this.state.halSuratMasuk.map((dt) => {
                                                                return dt;
                                                              })}
                                                              {this.state.setelahSuratMasuk}
                                                              {this.state.akhirSuratMasuk}
                                                            </div>
                                                          </div>
                                                        </>
                                                      ) : (
                                                        <div className="col-md-12" style={{ paddingTop: '20px' }}>
                                                          <h6 className="text-center mb-2 mt-2">Belum ada data</h6>
                                                        </div>
                                                      )}
                                                    </>
                                                  )}
                                                  <Modal
                                                    open={this.state.statusSuratMasuk.form}
                                                    onClose={this.tutupFormSuratMasuk}
                                                    styles={{ modal: { width: "80%" } }}
                                                  >
                                                    <div className="modal-header">
                                                      <h5 className="modal-title">{this.state.judul}</h5>
                                                    </div>
                                                    <Form className="theme-form" onSubmit={this.simpan}>
                                                      <div className="modal-body">
                                                        <input
                                                          className="form-control"
                                                          id="uuid"
                                                          type="hidden"
                                                          placeholder="Role"
                                                          defaultValue={this.state.dt.uuid}
                                                        />
                                                        <FormGroup className="row">
                                                          <Label
                                                            className="col-sm-3 col-form-label"
                                                            htmlFor="inputEmail3"
                                                          >
                                                            Nomor Surat
                                                          </Label>
                                                          <Col sm="9">
                                                            <input
                                                              name="nomor_surat"
                                                              className="form-control"
                                                              type="text"
                                                              placeholder={"Masukkan Nomor Surat"}
                                                              value={this.state.dt.nomor_surat}
                                                              onChange={e => this.handleChangeInputText(e,'nomor_surat')}
                                                              required
                                                            />
                                                          </Col>
                                                        </FormGroup>
                                                        <FormGroup className="row">
                                                          <Label
                                                            className="col-sm-3 col-form-label"
                                                            htmlFor="inputEmail3"
                                                          >
                                                            Uraian Singkat
                                                          </Label>
                                                          <Col sm="9">
                                                            <input
                                                              name="uraian_singkat"
                                                              className="form-control"
                                                              type="text"
                                                              placeholder={"Masukkan Uraian Singkat"}
                                                              value={this.state.dt.uraian_singkat}
                                                              onChange={e => this.handleChangeInputText(e,'uraian_singkat')}
                                                              required
                                                            />
                                                          </Col>
                                                        </FormGroup>
                                                        <FormGroup className="row">
                                                          <Label
                                                            className="col-sm-3 col-form-label"
                                                            htmlFor="inputEmail3"
                                                          >
                                                            Asal Surat Masuk
                                                          </Label>
                                                          <Col sm="9">
                                                            <input
                                                              name="dari"
                                                              className="form-control"
                                                              type="text"
                                                              placeholder={"Masukkan Asal Surat Masuk"}
                                                              value={this.state.dt.dari}
                                                              onChange={e => this.handleChangeInputText(e,'dari')}
                                                              required
                                                            />
                                                          </Col>
                                                        </FormGroup>
                                                        <FormGroup className="row">
                                                          <Label
                                                            className="col-sm-3 col-form-label"
                                                            htmlFor="inputEmail3"
                                                          >
                                                            Tujuan Surat
                                                          </Label>
                                                          <Col sm="9">
                                                            <input
                                                              name="tujuan_surat"
                                                              className="form-control"
                                                              type="text"
                                                              placeholder={"Masukkan Tujuan Surat"}
                                                              value={this.state.dt.tujuan_surat}
                                                              onChange={e => this.handleChangeInputText(e,'tujuan_surat')}
                                                              required
                                                            />
                                                          </Col>
                                                        </FormGroup>
                                                        <FormGroup className="row">
                                                          <Label
                                                            className="col-sm-3 col-form-label"
                                                            htmlFor="inputEmail3"
                                                          >
                                                            Perihal
                                                          </Label>
                                                          <Col sm="9">
                                                            <input
                                                              name="perihal"
                                                              className="form-control"
                                                              type="text"
                                                              placeholder={"Masukkan Perihal"}
                                                              value={this.state.dt.perihal}
                                                              onChange={e => this.handleChangeInputText(e,'perihal')}
                                                              required
                                                            />
                                                          </Col>
                                                        </FormGroup>
                                                        <FormGroup className="row">
                                                          <Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">
                                                            Tanggal Masuk
                                                          </Label>
                                                          <Col sm="9">
                                                          <Datetime
                                                            inputProps={{ placeholder: 'Pilih Tanggal', required: true }}
                                                            inputId="tanggal_masuk"
                                                            name="tanggal_masuk"
                                                            locale="id-ID"
                                                            timeFormat={false}
                                                            dateFormat="YYYY/MM/DD"
                                                            closeOnTab={true}
                                                            closeOnSelect={true}
                                                            initialValue={new Date()}
                                                            value={this.state.dt.tanggal_masuk}
                                                            onChange={e => {
                                                              this.gantiTgl(e, 'tanggal_masuk');
                                                            }}
                                                          />
                                                          </Col>
                                                        </FormGroup>
                                                        <FormGroup className="row">
                                                          <Label
                                                            className="col-sm-3 col-form-label"
                                                            htmlFor="inputEmail3"
                                                          >
                                                            Keterangan
                                                          </Label>
                                                          <Col sm="9">
                                                            <textarea
                                                              className="form-control"
                                                              id="keterangan"
                                                              placeholder="Masukkan Keterangan"
                                                              value={this.state.dt.keterangan}
                                                              onChange={e => this.handleChangeInputText(e,'keterangan')}
                                                              required
                                                            />
                                                          </Col>
                                                        </FormGroup>
                                                        <FormGroup className="row">
                                                          <Label
                                                            className="col-sm-3 col-form-label"
                                                            htmlFor="inputEmail3"
                                                          >
                                                            File
                                                          </Label>
                                                          <Col sm="9">
                                                            <input 
                                                              className="form-control"
                                                              placeholder="File"
                                                              id="file_lama" 
                                                              type="hidden" 
                                                              defaultValue={this.state.dt.file} 
                                                            />
                                                            <Dropzone
                                                              onDrop={(acceptedFiles) => this.processGbr(acceptedFiles)}
                                                              maxFiles={1}
                                                            >
                                                              {({ getRootProps, getInputProps }) => (
                                                                <section>
                                                                  <div
                                                                    {...getRootProps()}
                                                                    style={{
                                                                      minHeight: "100px",
                                                                      paddingTop: "40px",
                                                                      padding: "5px 5px 5px 5px",
                                                                      border: "1px solid #d2d2d2",
                                                                    }}
                                                                  >
                                                                    <input {...getInputProps()} />
                                                                    <div
                                                                      style={{
                                                                        justifyContent: "center",
                                                                        alignItems: "center",
                                                                      }}
                                                                    >
                                                                      <p className="text-center">
                                                                      {this.state.loadingSuratMasuk ? (
                                                                        <div className="row">
                                                                          <div className="col-sm-12" align="center">
                                                                            <img
                                                                              alt="loading"
                                                                              src={require("../assets/images/tes-loading.gif")}
                                                                              style={{
                                                                                borderRadius: "10px",
                                                                                width: '100px'
                                                                              }} />
                                                                          </div>
                                                                        </div>
                                                                        ) : this.state.link_gambar ? (
                                                                          <img
                                                                          src={require("../assets/images/file-icon.png")}
                                                                          style={{
                                                                          width: '270px'
                                                                          }}
                                                                          alt=""
                                                                      />
                                                                        ) : (
                                                                          <Label
                                                                            className="col-form-label text-center"
                                                                            htmlFor="inputEmail3"
                                                                          >
                                                                            Drag 'n' drop some files here, or click to select files
                                                                          </Label>
                                                                        )}
                                                                        {this.state.fileSuratMasuk ? (
                                                                          <div>{this.state.fileSuratMasuk}</div>
                                                                        ) : (
                                                                          ""
                                                                        )}
                                                                      </p>
                                                                    </div>
                                                                  </div>
                                                                </section>
                                                              )}
                                                            </Dropzone>
                                                          </Col>
                                                        </FormGroup>
                                                      </div>
                                                      <div className="modal-footer">
                                                        <button
                                                          type="button"
                                                          className="btn btn-warning"
                                                          disabled={this.state.statusSuratMasuk.btnForm}
                                                          onClick={this.tutupFormSuratMasuk}
                                                        >
                                                          Tutup
                                                        </button>
                                                        <button
                                                          type="submit"
                                                          className="btn btn-success"
                                                          disabled={this.state.statusSuratMasuk.btnForm}
                                                        >
                                                          Simpan
                                                        </button>
                                                      </div>
                                                    </Form>
                                                  </Modal>
                                                </>
                                              )
                                            }
                                          </div>
                                        </div>
                                      </div>
                                    </TabPane>
                                  </TabContent>
                                </div>
                              ) : ''}
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-4 pt-2 pl-0">
                          <div className="row m-0">
                            <div className="col-sm-12 col-md-12 pl-2 pr-2">
                              <div className="card mb-3" style={{ borderRadius: "21px" }}>
                                <div className="text-center">
                                {
                                  this.state.dataPerangkat.length > 0
                                  ?
                                    <div className="section-gambar-perangkat">
                                      <Carousel
                                        swipeable={false}
                                        draggable={false}
                                        showDots={false}
                                        responsive={responsive}
                                        ssr={true}
                                        infinite={true}
                                        autoPlay={true}
                                        autoPlaySpeed={3000}
                                        keyBoardControl={true}
                                        customTransition="all .5"
                                        transitionDuration={500}
                                        containerClass="carousel-container"
                                        deviceType={this.props.deviceType}
                                        itemClass="carousel-item-padding-40-px"
                                      >
                                        {
                                          this.state.dataPerangkat.map(dt => {
                                            return<>
                                              <div className="col-12 section-gambar-perangkat">
                                                <div className="row">
                                                  <div className="col-5 image-perangkat">
                                                    <img
                                                      id="foto_perangkat"
                                                      src={dt.foto_perangkat ? dt.foto_perangkat : require("../assets/images/ilustrasi-perangkat.png")}
                                                      alt="foto-perangkat"
                                                    />
                                                  </div>
                                                  <div className="col-7 description-perangkat">
                                                    <div className="bio">
                                                      <div className="jabatan">
                                                        {dt.data_jabatan && dt.data_jabatan.nama?dt.data_jabatan.nama:''}
                                                      </div>
                                                      <div className="nama">
                                                        {dt.data_penduduk && dt.data_penduduk.nama?dt.data_penduduk.nama:''}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </>
                                          })
                                        }
                                      </Carousel>
                                    </div>
                                  :
                                    this.state.loadingBannerDashboard ? (
                                      <div className="row">
                                        <div className="col-sm-12" align="center">
                                          <div style={{height:'20px'}}>
                                            &nbsp;
                                          </div>
                                          <img
                                            alt="loading"
                                            src={require("../assets/images/tes-loading.gif")}
                                            style={{
                                              borderRadius: "10px",
                                              width: '100px'
                                            }} />
                                        </div>
                                      </div>
                                    ) : (
                                      <img
                                        id="banner_dashboard"
                                        src={this.state.link_gambar_show}
                                        alt=""
                                        style={{
                                          maxHeight: "250px",
                                          width: "100%",
                                          borderRadius: "21px"
                                        }}
                                      />
                                    )
                                }
                                </div>
                              </div>
                            </div>
                            {/* Pelayanan Administratif */}
                            <div className="col-sm-12 col-md-12 mb-3 pl-2 pr-2" 
                              onClick={() => {
                                this.changeView('',this.state.tampilGrafik);
                              }}
                            >
                              <div className="pelayanan-administrasi">
                                {this.state.tampilGrafik === 'Grafik'
                                ?
                                  <>
                                    <i className="icofont icofont-envelope-open mr-2"></i>
                                    Pelayanan Administratif
                                  </>
                                :
                                  <>
                                    <i className="icofont icofont-chart-arrows-axis mr-2"></i>
                                    Grafik Potensi Desa
                                  </>
                                }
                              </div>
                            </div>
                            {/* pengajuan selesai */}
                            <div className="col-sm-12 col-md-12 mb-3 pl-2 pr-2">
                              <Link
                                to={{
                                  pathname: this.state.paid !== null && this.state.paid && this.state.lisensi !== null && this.state.lisensi ? process.env.PUBLIC_URL + "/admin/disposisi" : this.state.paid !== null && this.state.paid && this.state.lisensi !== null &&this.state.lisensi === false ? '/admin/layanan/expired': this.state.paid !== null && this.state.paid && this.state.lisensi === null ? '/admin/layanan/belum-setting' : '/admin/layanan/join-us',
                                  tabProps: "5"
                                }}
                              >
                                <div className="pengajuan-selesai">
                                  <b>
                                    <span>
                                      {/* <b>24%</b> */}
                                      {this.state.jumlahSelesai}
                                    </span>
                                    <h4>Pengajuan Selesai</h4>
                                    {/* <span>100 Pengajuan</span> */}
                                  </b>
                                </div>
                              </Link>
                            </div>
                            {/* pengajuan menunggu eksekusi */}
                            <div className="col-sm-6 col-md-6 pl-2 pr-2">
                              <Link
                                to={{
                                  pathname: this.state.paid !== null && this.state.paid && this.state.lisensi !== null && this.state.lisensi ? process.env.PUBLIC_URL + "/admin/disposisi" : this.state.paid !== null && this.state.paid && this.state.lisensi !== null &&this.state.lisensi === false ? '/admin/layanan/expired': this.state.paid !== null && this.state.paid && this.state.lisensi === null ? '/admin/layanan/belum-setting' : '/admin/layanan/join-us',
                                  tabProps: "2"
                                }}
                              >
                                <div className="pengajuan-menunggu-eksekusi mb-3">
                                  <b>
                                    <span>{this.state.jumlahMenungguEksekusi}</span>
                                    <h4>Pengajuan</h4>
                                    <h6>Menunggu Eksekusi</h6>
                                  </b>
                                </div>
                              </Link>
                            </div>
                            {/* verifikasi menunggu eksekusi */}
                            <div className="col-sm-6 col-md-6 pl-2 pr-2">
                              <Link
                                to={{
                                  pathname: this.state.paid !== null && this.state.paid && this.state.lisensi !== null && this.state.lisensi ? process.env.PUBLIC_URL + "/admin/verifikasi" : this.state.paid !== null && this.state.paid && this.state.lisensi !== null &&this.state.lisensi === false ? '/admin/layanan/expired': this.state.paid !== null && this.state.paid && this.state.lisensi === null ? '/admin/layanan/belum-setting' : '/admin/layanan/join-us',
                                  tabProps: "2"
                                }}
                              >
                                <div className="verifikasi-menunggu-eksekusi mb-3">
                                  <b>
                                    <span>
                                      {this.state.jumlahVerifikasiMenungguEksekusi}
                                    </span>
                                    <h4>Verifikasi</h4>
                                    <h6>Menunggu Verifikasi</h6>
                                  </b>
                                </div>
                              </Link>
                            </div>
                            {/* berita/artikel */}
                            {
                              this.state.dataBerita.length > 0
                              ?
                                <div className="section-berita col-sm-12 col-md-12 pl-2 pr-2">
                                  <Carousel
                                    swipeable={false}
                                    draggable={false}
                                    showDots={false}
                                    responsive={responsive}
                                    ssr={true}
                                    infinite={true}
                                    autoPlay={true}
                                    autoPlaySpeed={3000}
                                    keyBoardControl={true}
                                    customTransition="all .5"
                                    transitionDuration={500}
                                    containerClass="carousel-container"
                                    deviceType={this.props.deviceType}
                                    itemClass="carousel-item-padding-40-px"
                                  >
                                    {
                                      this.state.dataBerita.map((dt, index) => {
                                        let dateBerita = new Date(dt.created_at)
                                        let convDate = Math.floor(dateBerita.getTime() / 1000);;
                                        let slugBerita = dt.judul.replace(/ /g,"-").toLowerCase();
                                        let linkDetailBerita = this.state.dataSetting?this.state.dataSetting.website +'news/' + convDate + '/' + slugBerita:''
                                        
                                        return<>
                                          <div className="card-berita">
                                            <div className="image-berita">
                                              <img
                                                src={dt.link_gambar}
                                                alt="image-berita"
                                                className="center"
                                              />
                                            </div>
                                            <div className="card-bottom">
                                              <div className="count-berita">
                                                <div className="content-count">
                                                  {index+1} dari {this.state.dataBerita.length}
                                                </div>
                                              </div>
                                              <div className="judul-berita">
                                                {dt.judul}
                                              </div>
                                              <div className="bottom-berita">
                                                <a href={linkDetailBerita} target='_blank' rel="noopener noreferrer">
                                                  <button className="btn-berita-selengkapnya">
                                                    <span>
                                                      Baca Selengkapnya 
                                                    </span>
                                                    <span>
                                                      <i className="fa fa-arrow-right"></i>
                                                    </span>
                                                  </button>
                                                </a>

                                                <span className="date-berita">
                                                  <span>
                                                    {formatDMY(dateBerita)}
                                                  </span>
                                                  <span>
                                                    | 
                                                  </span>
                                                  <span>
                                                    {formatHIS(dateBerita)}
                                                  </span>
                                                </span>

                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      })
                                    }
                                  </Carousel>
                                </div>
                              :
                              <>
                                {/* catatan menunggu eksekusi */}
                                <div className="col-sm-6 col-md-6 pl-2 pr-2">
                                  <Link
                                    to={{
                                      pathname: this.state.paid !== null && this.state.paid && this.state.lisensi !== null && this.state.lisensi ? process.env.PUBLIC_URL + "/admin/catatan" : this.state.paid !== null && this.state.paid && this.state.lisensi !== null &&this.state.lisensi === false ? '/admin/layanan/expired': this.state.paid !== null && this.state.paid && this.state.lisensi === null ? '/admin/layanan/belum-setting' : '/admin/layanan/join-us',
                                      tabProps: "1"
                                    }}
                                  >
                                    <div className="catatan-menunggu-eksekusi mb-3">
                                      <b>
                                        <span>
                                          {this.state.jumlahCatatanMenungguEksekusi}
                                        </span>
                                        <h4>Catatan</h4>
                                        <h6>Belum Selesai</h6>
                                      </b>
                                    </div>
                                  </Link>
                                </div>
                                {/* pengaduan menunggu eksekusi */}
                                <div className="col-sm-6 col-md-6 pl-2 pr-2">
                                  <div className="pengaduan-menunggu-eksekusi mb-3">
                                    <b>
                                      <span>{this.state.jumlahPengaduanDiajukan}</span>
                                      <h4>Pengaduan</h4>
                                      <h6>Diajukan</h6>
                                    </b>
                                  </div>
                                </div>
                              </>
                            }
                          </div>
                        </div>
                      </>
                    }
                  </div>
                </div>
                <div className="col-sm-12">
                  <div className="row" style={{ marginTop: "50px" }}>
                    <div className="col-sm-6 col-md-6 col-lg-3 mb-4">
                      <a
                        href="#"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <div style={{ color: "#707070", textAlign: "center" }}>
                          <img
                            src={require("../assets/images/logo-bms.png")}
                            alt=""
                            style={{ maxWidth: "90%", maxHeight: "60px" }}
                          />
                        </div>
                      </a>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-3 mb-4">
                      <div
                        style={{
                          color: "#707070",
                          textAlign: "center",
                          wordWrap: "break-word"
                        }}
                      >
                        <h5>
                          <b>PT. Bumi Manusia Sadparamita</b>
                        </h5>
                        {/* <h6>We Make IT Easier</h6> */}
                        <h6>
                          {
                            this.state.dataVersion?
                              <font onClick={(e) => this.openVersion()}><u>versi {this.state.dataVersion.version}.</u></font> 
                            :
                            <></>
                          }
                          {new Date().getFullYear()} All Rights Reserved
                        </h6>
                        <Modal
                          open={this.state.status.modalVersion}
                          onClose={() => {
                            this.setState({
                            	status:{
                            		...this.state.status,
                            		modalVersion: false,
                            	}
                            })
                          }}
                          styles={{ 
                            modal: {
                                width: '80%',
                                // height: '90%',
                                // maxHeight: 'unset',
                                maxWidth: 'unset',
                              }
                          }}
                          closeOnEsc={false}
                          closeOnOverlayClick={false}
                        >
                          <div
                            className="modal-body"
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              flexDirection: 'column',
                              height: '90%',
                            }}
                          >
                              <center>
                                <span><h4><b>Update {this.state.dataVersion? this.state.dataVersion.version : ''} Version</b></h4></span><br/>
                              </center>
                              Apa yang baru pada update-an versi {this.state.dataVersion? this.state.dataVersion.version : ''}?
                              <br/>
                              {
                                this.state.dataVersion
                                ?
                                  htmlToReactParser.parse(this.state.dataVersion.keterangan)
                                  :
                                  <></>
                              }
                          </div>
                          <div
                            className="modal-footer"
                            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                          >
                            <button
                              onClick={() => {
                                this.setState({
                                  status:{
                                    ...this.state.status,
                                    modalVersion: false,
                                  },
                                })
                              }}
                              className="btn btn-warning"
                            >
                              Tutup
                            </button>
                          </div>
                        </Modal>
                      </div>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-3 mb-4">
                      <div
                        style={{
                          color: "#707070",
                          textAlign: "center",
                          wordWrap: "break-word"
                        }}
                      >
                        <h5>
                          <b>Hubungi Kami</b>
                        </h5>
                        <a
                          href="tel: (0857) 7610 4210"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#707070" }}
                        >
                          <h6>(0857) 7610 4210</h6>
                        </a>
                        <a
                          href="mailto: bamstedjo3110@gmail.com"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#707070" }}
                        >
                          <h6>bamstedjo3110@gmail.com</h6>
                        </a>
                      </div>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-3 mb-4">
                      <div
                        style={{
                          color: "#707070",
                          textAlign: "center",
                          wordWrap: "break-word"
                        }}
                      >
                        <span style={{ fontSize: "30px" }}>
                          <a
                            href={contact_person.wa}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#707070" }}
                          >
                            <i className="icofont icofont-brand-whatsapp"></i>{" "}
                          </a>
                          <a
                            href="#"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#707070" }}
                          >
                            <i className="fa fa-instagram"></i>
                          </a>
                        </span>
                        <a
                          href="#"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#707070" }}
                        >
                          {/* <h6>www.terpadu.id</h6> */}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) 
            : this.state.akun.sub.data_role.nama_role === "Admin Website" ? (
              <div className="row">
                <div className="col-sm-12">
                  <div
                    className="card"
                    style={{
                      backgroundColor: "#f6f7fb",
                      borderRadius: '21px'
                    }}
                  >
                    <div className="card-body pb-1">
                      <div className="row">
                        <div className="col-sm-12 col-md-12 pl-2 pr-2 mb-3" style={{textAlign: 'center', paddingTop:'120px', paddingBottom:'120px'}}>
                          <h4>Selamat Datang di Halaman Admin Website {Nama_DESA}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
            : this.state.akun.sub.data_role.nama_role === "Enumerator" ? (
              <div className="row">
                <div className="col-sm-12">
                  <div
                    className="card"
                    style={{
                      backgroundColor: "#f6f7fb",
                      borderRadius: '21px'
                    }}
                  >
                    <div className="card-body pb-1">
                      <div className="row">
                        <div className="col-sm-12 col-md-12 pl-2 pr-2 mb-3" style={{textAlign: 'center', paddingTop:'120px', paddingBottom:'120px'}}>
                          <h4>Selamat Datang di Halaman Admin Kependudukan {Nama_DESA}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
            : (
              <div className="row">
                <div className="col-sm-12">
                  <div
                    className="card"
                    style={{
                      backgroundColor: "#f6f7fb",
                      borderRadius: '21px'
                    }}
                  >
                    <div className="card-body pb-1">
                      <div className="row">
                        {/* pengajuan selesai */}
                        <div className="col-sm-12 col-md-12 pl-2 pr-2 mb-3">
                          <div className="pengajuan-selesai">
                            <b>
                              <span>
                                {/* <b>24%</b> */}
                                {this.state.jumlahSelesai}
                              </span>
                              <h4>Pengajuan Selesai</h4>
                              {/* <span>100 Pengajuan</span> */}
                            </b>
                          </div>
                        </div>
                        {/* pengajuan menunggu eksekusi */}
                        <div className="col-sm-6 col-md-6 pl-2 pr-2 mb-3">
                          <div className="pengajuan-menunggu-eksekusi">
                            <b>
                              <span>{this.state.jumlahMenungguEksekusi}</span>
                              <h4>Pengajuan</h4>
                              <h6>Menunggu Eksekusi</h6>
                            </b>
                          </div>
                        </div>
                        {/* pengaduan menunggu eksekusi */}
                        <div className="col-sm-6 col-md-6 pl-2 pr-2 mb-3">
                          <div className="pengaduan-menunggu-eksekusi">
                            <b>
                              <span>{this.state.jumlahPengaduanDiajukan}</span>
                              <h4>Pengaduan</h4>
                              <h6>Diajukan</h6>
                            </b>
                          </div>
                        </div>
                        {/* catatan menunggu eksekusi */}
                        <div className="col-sm-6 col-md-6 pl-2 pr-2 mb-3">
                          <div className="catatan-menunggu-eksekusi">
                            <b>
                              <span>
                                {this.state.jumlahCatatanMenungguEksekusi}
                              </span>
                              <h4>Catatan</h4>
                              <h6>Belum Selesai</h6>
                            </b>
                          </div>
                        </div>
                        {/* verifikasi menunggu eksekusi */}
                        <div className="col-sm-6 col-md-6 pl-2 pr-2 mb-3">
                          <div className="verifikasi-menunggu-eksekusi">
                            <b>
                              <span>
                                {this.state.jumlahVerifikasiMenungguEksekusi}
                              </span>
                              <h4>Verifikasi</h4>
                              <h6>Menunggu Verifikasi</h6>
                            </b>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
            :
            <>
              Selamat Datang
            </>
          }
          {/* </div> */}
        </div>
      </div>
    );
    }
  }
}

export default Dashboard;